import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex height-100 width-100" }
const _hoisted_2 = {
  class: "taggy-flow-canvas-shell d-flex flex-column height-100",
  "data-taggy-flow-canvas": ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "open-output-popup-dialog" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center width-100 height-100"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_6 = { class: "card border-0 background-fb" }
const _hoisted_7 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_8 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_9 = {
  key: 0,
  class: "margin-top-10 d-flex justify-content-between"
}
const _hoisted_10 = { class: "margin-top-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "warning-div"
}
const _hoisted_13 = { class: "warning-text" }
const _hoisted_14 = { class: "margin-top-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "warning-div"
}
const _hoisted_17 = { class: "warning-text" }
const _hoisted_18 = { class: "margin-top-10 d-flex align-items-start justify-content-between" }
const _hoisted_19 = { class: "d-flex flex-column align-items-start" }
const _hoisted_20 = { class: "d-flex flex-column align-items-end" }
const _hoisted_21 = {
  key: 1,
  class: "margin-top-20 d-flex align-items-center justify-content-between"
}
const _hoisted_22 = { class: "d-flex align-items-center gap-1" }
const _hoisted_23 = {
  key: 2,
  class: "margin-top-10 d-flex align-items-start justify-content-between"
}
const _hoisted_24 = { class: "d-flex flex-column align-items-start" }
const _hoisted_25 = {
  key: 3,
  class: "margin-top-20 d-flex justify-content-between"
}
const _hoisted_26 = {
  key: 0,
  class: "d-flex flex-column align-items-start gap-2"
}
const _hoisted_27 = {
  key: 1,
  class: "d-flex flex-column align-items-end gap-2"
}
const _hoisted_28 = {
  key: 4,
  class: "margin-top-20 d-flex justify-content-between"
}
const _hoisted_29 = {
  key: 0,
  class: "d-flex flex-column align-items-start gap-2"
}
const _hoisted_30 = {
  key: 1,
  class: "d-flex flex-column align-items-end gap-2"
}
const _hoisted_31 = {
  key: 5,
  class: "margin-top-20 d-flex flex-row align-items-start gap-2"
}
const _hoisted_32 = {
  key: 6,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_33 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_34 = ["src"]
const _hoisted_35 = {
  key: 7,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_36 = { style: {"float":"left"} }
const _hoisted_37 = ["src"]
const _hoisted_38 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 8,
  class: "margin-top-10 d-flex flex-column gap-2"
}
const _hoisted_41 = {
  key: 9,
  class: "margin-top-20"
}
const _hoisted_42 = { class: "bold" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = {
  key: 10,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_45 = { class: "d-flex w-100" }
const _hoisted_46 = { style: {"float":"left"} }
const _hoisted_47 = {
  key: 11,
  class: "margin-top-10 d-flex flex-column align-items-start gap-2"
}
const _hoisted_48 = { class: "d-flex flex-row align-items-start gap-2" }
const _hoisted_49 = {
  class: "d-flex justify-content-between align-items-center w-100",
  style: {"padding":"4px 0"}
}
const _hoisted_50 = { class: "d-flex align-items-center gap-2" }
const _hoisted_51 = {
  class: "d-flex justify-content-between align-items-center w-100",
  style: {"padding":"4px 0"}
}
const _hoisted_52 = { class: "d-flex align-items-center gap-1" }
const _hoisted_53 = { class: "scrollable-tooltip-content" }
const _hoisted_54 = {
  key: 14,
  class: "margin-top-10 d-flex flex-column align-items-start gap-2"
}
const _hoisted_55 = { class: "d-flex flex-row align-items-start gap-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_58 = {
  key: 15,
  class: "margin-top-10 d-flex flex-column gap-2"
}
const _hoisted_59 = { class: "d-flex flex-column gap-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Notify Users"), -1)
const _hoisted_61 = {
  class: "emailValidation",
  id: "invalidEmail"
}
const _hoisted_62 = { class: "card border-0 background-fb" }
const _hoisted_63 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_64 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_65 = { class: "d-flex justify-content-between" }
const _hoisted_66 = { class: "d-flex align-items-center justify-content-end gap-2 add-btn-wrapper" }
const _hoisted_67 = {
  key: 1,
  class: "d-flex align-items-center full-width justify-content-center margin-top-10"
}
const _hoisted_68 = { class: "udv-field-column" }
const _hoisted_69 = { class: "udv-field-column" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "udv-action-column" }, null, -1)
const _hoisted_71 = ["id"]
const _hoisted_72 = ["id"]
const _hoisted_73 = { class: "d-flex flex-column align-items-center justify-content-center margin-top-10 udv-action-column" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = { class: "card-header header-drawer d-flex flex-row align-items-center justify-content-between" }
const _hoisted_77 = { class: "card-body filter-condition-body overflow-auto" }
const _hoisted_78 = { class: "filter-condition-panel" }
const _hoisted_79 = { class: "d-flex justify-content-end align-items-center margin-top-10 filter-condition-actions" }
const _hoisted_80 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_81 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_82 = { class: "tree-container" }
const _hoisted_83 = { class: "custom-tree-node" }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_86 = { class: "right-menu-bar height-100 d-flex flex-column justify-content-between" }
const _hoisted_87 = { class: "d-flex flex-column" }
const _hoisted_88 = {
  key: 0,
  class: "nav flex-column nav-tabs no-border height-100"
}
const _hoisted_89 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_90 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_91 = ["onClick"]
const _hoisted_92 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_93 = {
  key: 1,
  class: "nav flex-column nav-tabs no-border height-100"
}
const _hoisted_94 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_95 = { class: "nav flex-column nav-tabs no-border height-100" }
const _hoisted_96 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_97 = { class: "nav flex-column nav-tabs no-border height-100" }
const _hoisted_98 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_99 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_100 = { class: "d-flex flex-column align-items-center justify-content-center mt-auto mb-auto" }
const _hoisted_101 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_102 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_103 = ["disabled"]
const _hoisted_104 = ["disabled"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "button-separator" }, null, -1)
const _hoisted_106 = ["disabled"]
const _hoisted_107 = {
  key: 2,
  class: "button-separator"
}
const _hoisted_108 = ["disabled"]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "button-separator" }, null, -1)
const _hoisted_110 = ["disabled"]
const _hoisted_111 = ["disabled"]
const _hoisted_112 = ["disabled"]
const _hoisted_113 = { class: "loader-div-40" }
const _hoisted_114 = ["src"]
const _hoisted_115 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { id: "proceed-step-popup-dialog" }, null, -1)

import {
  computed,
  defineAsyncComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  provide,
  reactive,
  ref,
  watch,
} from "vue";
import { cloneDeep, uniqueId } from "lodash-es";
import { TYPE } from "vue-toastification";
import {
  ElButton,
  ElCheckbox,
  ElColorPicker,
  ElInput,
  ElScrollbar,
  ElOption,
  ElSelect,
  ElSlider,
  ElSwitch,
  ElTag,
  ElTooltip,
  ElTree,
  ElDivider,
} from "element-plus";
import { v4 as uuidv4 } from "uuid";
import {
  addFlow,
  connectWebsocket,
  convertDate,
  createStepLinesChunked,
  editFlow,
  Flow,
  getConnections,
  getFlow,
  getModifiedUser,
  isRunning,
  removeLeaderLines,
  revertFlow,
  startFlow,
  statusColor,
  stopFlow,
  getSystemVariables,
  getExpressionDetails,
  getConfigurationFramework,
  updateConfigurationFramework,
  getOrganizationsExecutions,
  getOrganizationDefault,
  getExecutionProperties,
  getCreatedByByFlowIdAndVersion,
  getCreatedAtByFlowIdAndVersion,
  validateCronExpression,
  getTenantDefault,
  convertFlowToNewUi,
  isNewUiEnabledForTenant,
  isAIFlowReportingEnabledForTenant,
  isAIWizardEnabledForTenant,
  isAISkillGeneratorEnabledForTenant,
  generateFlowSkill,
  getFlowSkillStatus,
  persistSkillGenJob,
  clearSkillGenJob,
  getPersistedSkillGenJob,
  generateAIReport,
  updateAIReport,
  getAIReport,
  checkAIReportExists,
  getProperty,
} from "@/flow/services/flow.service";
import { getOrganizationsConnectorList } from "@/connection/services/connection.service";
import { confirmAndRemoveUdv } from "@/flow/services/udv.service";
import { updateConfiguraitonSettings } from "@/settings/services/settings.service";
import { getUserById } from "@/user/services/user.service";
import { currentRoute, router } from "@/core/router";
import { showAlert, showConfirm } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { hasPermission, updateSinglePreference, authInfo } from "@/core/auth";
import { changeListItemOfBreadcrumb } from "@/core/layout";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { isAnyRouteHasNotFilterProp } from "@/flow/validations/isAnyRouteHasNotFilterProp";
import { flushFlowInputs } from "@/flow/application/conditionInputFlushRegistry";
import { findInvalidStepFilterIndex } from "@/flow/validations/findInvalidStepFilterIndex";
import { isAnyStepHasNotConnectorProp } from "@/flow/validations/isAnyStepHasNotConnectorProp";
import { useActivity } from "@/flow/application/activity";
import { getOutputListForAllStep } from "@/flow/utils/getOutputListForAllStep";
import { useAddPositionToStep } from "@/flow/application/useAddPositionToStep";
import { useSyncInputData } from "@/flow/application/useSyncInputData";
import { useStepDisplay } from "@/core/composables/useStepDisplay";
import { PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY } from "@/flow/utils/outputReferenceUtils";
import {
  preserveUdvChangeMaps,
  stripUdvValueOnlyRows,
} from "@/flow/utils/preserveUdvChangeMaps";
import { AddedStep, ChangedStep, RemovedStep } from "@/flow/types";
import { useLoopLines } from "@/flow/application/useLoopLines";
import {
  findStepOrRouteByUniqueId,
  Flow as FlowType,
} from "@/flow/domain/flow";
import timezoneOffsets from "@/flow/utils/timezoneOffset";
import { onBeforeRouteLeave } from "vue-router";
import { EventBus } from "@/eventBus";
import { getFlowLogZipById } from "@/dashboard/services/flow_log.service";
import WebsocketUrlProvider from "@/core/services/websocketUrl.provider";
import WizardDrawer from "@/flow/components/wizard/WizardDrawer.vue";
import FlowPreviewOverlay from "@/flow/components/wizard/FlowPreviewOverlay.vue";
import TaggyPromo from "@/flow/components/wizard/TaggyPromo.vue";
import {
  consumeWizardReopenAfterRefresh,
  initializeWizardSessionScope,
  resetPersistedWizardSession,
} from "@/flow/composables/useWizardSession";
import { buildWizardFlowSnapshot } from "@/flow/utils/wizardFlowSnapshot";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import {
  isSkillGenerationEnabled,
  restoreSkillGenerationToggle,
  saveSkillGenerationToggle,
} from "./skillGenerationToggle";
import { getMetaoutputListForAllStep } from "../utils/getMetaoutputListForAllStep";

const EDIT_STEP_BASE_MIN_WIDTH = 520;
const CONDITION_BASE_MIN_WIDTH = 600;
const ROUTER_BASE_MIN_WIDTH = 600;
const WIZARD_BASE_MIN_WIDTH = 520;
const MAX_DRAWER_RENDER_WIDTH = 1500;
const WIZARD_HISTORY_DRAWER_WIDTH = 450;

const FUNCTION_DRAWER_WIDTH = 450;

const FUNCTION_EXPRESSION_DRAWER_WIDTH = 600;


export default /*#__PURE__*/_defineComponent({
  __name: 'EditFlow',
  setup(__props) {

let skillGenPollIntervalMs = 15_000;
let skillGenPollTimeoutMs = 15 * 60 * 1000;

const EditStep = defineAsyncComponent(
  () => import(/* webpackPreload: true */ "@/flow/components/EditStep.vue")
);
const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);
const FlowVersions = defineAsyncComponent(
  () => import("@/flow/components/FlowVersions.vue")
);

provide(PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY, false);
const StepContainer = defineAsyncComponent(
  () => import("@/flow/components/StepContainer.vue")
);
const EditRoute = defineAsyncComponent(
  () => import("@/flow/components/EditRoute.vue")
);
const Condition = defineAsyncComponent(
  () => import("@/flow/components/Condition.vue")
);
const EditDelay = defineAsyncComponent(
  () => import("@/flow/components/EditDelay.vue")
);
const Activities = defineAsyncComponent(
  () => import("@/activity/pages/Activities.vue")
);
const CronEditor = defineAsyncComponent(
  () => import("@/flow/components/cron-editor/pages/CronEditor.vue")
);
const OutputDataDialog = defineAsyncComponent(
  () => import("@/flow/components/OutputDataDialog.vue")
);

const { t } = i18n.global;
const wizardDrawerVisible = ref(false);
const wizardHistoryVisible = ref(false);
const aiWizardEnabled = ref(false);
const wizardDrawerRef = ref<InstanceType<typeof WizardDrawer> | null>(null);
const wizardPreviewActive = ref(false);
const wizardPreviewFlowSpec = ref<any>(null);
const wizardPreviewSubmitting = ref(false);
const wizardReviewActive = computed(
  () => wizardPreviewActive.value && wizardDrawerVisible.value
);
const connections = ref([]);
// Connectors that need no per-tenant configuration (connectionOptional) can be used as steps
// without a Connection. We surface them as synthetic, connection-shaped entries blended into the
// picker alongside real connections.
const connectors = ref([]);
const combinedConnections = computed(() => {
  const optional = (connectors.value || [])
    .filter((c: any) => c.connectionOptional)
    .map((c: any) => ({
      id: `connector:${c.connectorSpecId}`,
      name: c.name,
      active: true,
      connectionOptional: true,
      connector: {
        connectorSpecId: c.connectorSpecId,
        connectorType: c.connectorType,
        hasConsumer: c.hasConsumer,
        name: c.name,
      },
    }));
  return [...connections.value, ...optional];
});
const isVersionChanged = ref(false);
const steps = ref<any[]>([]);
const flow = ref({
  name: "",
  active: true,
  scheduleType: "NONE",
  latest: true,
} as Flow);

function openWizardDrawer() {
  if (!aiWizardEnabled.value) {
    return;
  }
  if (wizardDrawerVisible.value) {
    wizardDrawerVisible.value = false;
    return;
  }
  closeDrawer();
  userVariableVisible.value = false;
  configurationVisible.value = false;
  conditionVisible.value = false;
  delayVisible.value = false;
  routerVisible.value = false;
  infoVisible.value = false;
  if (activeTab.value !== 1) {
    activeTab.value = 1;
    resetStepLines();
  }
  wizardDrawerVisible.value = true;
}

function closeWizardDrawer() {
  wizardHistoryVisible.value = false;
  wizardDrawerVisible.value = false;
  wizardPreviewActive.value = false;
  wizardPreviewFlowSpec.value = null;
  wizardPreviewSubmitting.value = false;
}

async function handleHideTeggyPromo() {
  await updateSinglePreference("hideTeggyAssistantPromo", true);
}

function handleWizardApprovalStateChange(payload: {
  active: boolean;
  flowSpec: any;
  loading: boolean;
}) {
  wizardPreviewActive.value = payload.active;
  wizardPreviewFlowSpec.value = payload.flowSpec;
  wizardPreviewSubmitting.value = payload.active && payload.loading;
}

function handleWizardPreviewApprove() {
  if (wizardDrawerRef.value) wizardDrawerRef.value.handleApprove();
}

function handleWizardPreviewReject() {
  wizardPreviewActive.value = false;
  wizardPreviewFlowSpec.value = null;
  wizardPreviewSubmitting.value = false;
  if (wizardDrawerRef.value) wizardDrawerRef.value.handleReject();
}

function handleWizardPreviewFeedback(feedback: string) {
  wizardPreviewActive.value = false;
  wizardPreviewFlowSpec.value = null;
  wizardPreviewSubmitting.value = false;
  if (wizardDrawerRef.value) wizardDrawerRef.value.handleFeedback(feedback);
}

function handleWizardHistoryVisibilityChange(isVisible: boolean) {
  wizardHistoryVisible.value = isVisible;
}

async function handleWizardFlowCreated(createdFlowPayload?: any) {
  closeWizardDrawer();
  const createdFlowId = createdFlowPayload?.id;
  const createdFlowVersion = Number(createdFlowPayload?.version || 1);

  const { pathname } = window.location;
  let localePrefix = "";
  if (pathname.startsWith("/tr/")) {
    localePrefix = "/tr";
  } else if (pathname.startsWith("/en/")) {
    localePrefix = "/en";
  }

  if (!createdFlowId) {
    window.location.assign(`${localePrefix}/flows`);
    return;
  }

  window.location.assign(
    `${localePrefix}/flows/edit/${createdFlowId}/${createdFlowVersion}`
  );
}

onBeforeRouteLeave((to, from, next) => {
  if (to.query.skipUnsavedCheck === "true") {
    next();
    return;
  }
  if (!flowId.value || isVersionChanged.value) {
    isVersionChanged.value = false;
    next();
    return;
  }
  if (isAnyChange.value) {
    showConfirm(
      "warning",
      t("Flow.UnsavedChanges"),
      t("Flow.UnsavedChangesMessage")
    ).then((confirmed) => {
      if (confirmed) {
        isAnyChange.value = false;
        EventBus.isAnyChange = false;
        next();
      } else {
        next(false);
      }
    });
  } else {
    next();
  }
});

const backgroundColor = ref(
  getPreferenceValue("editFlowBackground")
    ? getPreferenceValue("editFlowBackground")
    : "#b5c0cd"
);
const predefinedColors = ref([
  "rgba(191, 181, 205, 1)",
  "#b5c0cd",
  "rgba(251, 193, 123, 0.64)",
  "rgba(144, 238, 144, 0.5)",
  "rgba(121, 166, 167, 0.63)",
  "rgba(146, 199, 251, 1)",
  "rgba(228, 172, 181, 1)",
  "rgba(238, 231, 191, 1)",
  "rgba(165, 249, 165, 0.5)",
  "rgba(115, 184, 186, 1)",
  "hsla(209, 100%, 56%, 0.73)",
  "rgba(190, 226, 227, 1)",
  "#c7158577",
]);

const pageOpen = ref(true);
const updatedFlow = ref();

const stepSimulating = ref(false);
const simulationDataRefreshKey = ref(0);
const popUpOpen = ref(false);

const outputList = ref([]);
const metaoutputList = ref([]);
const componentKey = ref(1);

const selectedStep = ref();
const selectedIndex = ref();
const isStepInRouter = ref(false);
const dragIndex = ref();

const drawerVisible = ref(false);

const functionsVisible = ref(false);

const editStepKey = ref(0);

let dragged = false;

const flowName = ref("");

const nextRunTime = ref("");

const stepLoading = ref(false);

const responseLoading = ref(false);

const configResponseLoading = ref(false);

const pageLoading = ref(false);

const pendingData = ref();

const updatedConfigurations = ref({});

const paddingTopForCentering = ref("1 rem");

const paddingLeftForCentering = ref("1 rem");

const paddingRightForCentering = ref("1 rem");

const paddingBottomForCentering = ref("1 rem");

const flowId = computed(() => currentRoute.value.params.id as string);

const version = computed(() => currentRoute.value.params.version as string);

const taggyScreenKey = computed(() =>
  flowId.value ? `${flowId.value}:${version.value || "current"}` : "create-flow"
);

const isTeggyPromoHidden = computed(() =>
  Boolean(getPreferenceValue("hideTeggyAssistantPromo"))
);

const isTaggySurfaceVisible = computed(
  () => activeTab.value === 1 && !pageLoading.value
);

const currentWizardFlowSnapshot = computed(() => {
  if (!flow.value) {
    return null;
  }

  return buildWizardFlowSnapshot({
    flow: flow.value,
    steps: useAddPositionToStep(cloneDeep(steps.value)),
  });
});

const flowRunning = computed(() => isRunning(flowStatus.value));

const canStopFlow = computed(() => hasPermission("FLOWS.LIST.STOP"));

const isEditStepPanelMounted = computed(
  () =>
    drawerVisible.value &&
    !conditionVisible.value &&
    !infoVisible.value &&
    !!editStepRef.value
);

const showSimulateControls = computed(
  () =>
    isEditStepPanelMounted.value &&
    !!selectedStep.value &&
    isPersistedFlowStep(selectedStep.value) &&
    !!flow.value.latest &&
    selectedStep.value.type !== "ROUTER"
);

const showSimulateRegular = computed(
  () => showSimulateControls.value && !selectedStep.value?.parentId
);

const showSimulateRouterChild = computed(
  () => showSimulateControls.value && !!selectedStep.value?.parentId
);

function isPersistedFlowStep(step: any) {
  return (
    typeof step?.id === "string" &&
    !step.id.includes("new") &&
    (typeof step?.createdAt === "string" || typeof step?.updatedAt === "string")
  );
}

const disableSimulateButton = computed(() => {
  if (!selectedStep.value) return true;
  return stepSimulating.value || !isPersistedFlowStep(selectedStep.value);
});

const isResizing = ref(false);

const functionDrawerReservePx = computed<number>(() => {
  if (!functionsVisible.value) return 0;
  return expressionDrawer.value
    ? FUNCTION_EXPRESSION_DRAWER_WIDTH
    : FUNCTION_DRAWER_WIDTH;
});

const currentEditStepWidthPx = computed(() =>
  Math.round(editStepWidthPx.value + functionDrawerReservePx.value)
);

const currentConditionWidthPx = computed(() =>
  Math.round(conditionWidthPx.value + functionDrawerReservePx.value)
);

const currentRouterWidthPx = computed(() =>
  Math.round(routerWidthPx.value + functionDrawerReservePx.value)
);

const minEditStepWidth = computed<number>(
  () => EDIT_STEP_BASE_MIN_WIDTH + functionDrawerReservePx.value
);

const minConditionWidth = computed<number>(
  () => CONDITION_BASE_MIN_WIDTH + functionDrawerReservePx.value
);

const minRouterWidth = computed<number>(
  () => ROUTER_BASE_MIN_WIDTH + functionDrawerReservePx.value
);

const maxEditStepWidth = computed<number>(() =>
  functionsVisible.value ? 1350 : 1850
);

function getDrawerBaseMaxWidth(minBaseWidth: number) {
  return Math.max(
    minBaseWidth,
    Math.min(
      maxEditStepWidth.value,
      MAX_DRAWER_RENDER_WIDTH - functionDrawerReservePx.value
    )
  );
}

function clampDrawerBaseWidth(width: number, minBaseWidth: number) {
  return clamp(width, minBaseWidth, getDrawerBaseMaxWidth(minBaseWidth));
}

function getWizardBaseMaxWidth() {
  return Math.max(
    WIZARD_BASE_MIN_WIDTH,
    MAX_DRAWER_RENDER_WIDTH -
      (wizardHistoryVisible.value ? WIZARD_HISTORY_DRAWER_WIDTH : 0)
  );
}

function clampWizardBaseWidth(width: number) {
  return clamp(width, WIZARD_BASE_MIN_WIDTH, getWizardBaseMaxWidth());
}

const editStepWidthPx = ref<number>(
  clampDrawerBaseWidth(
    getNumberPref("editStepBoxWidthPx", EDIT_STEP_BASE_MIN_WIDTH),
    EDIT_STEP_BASE_MIN_WIDTH
  )
);

const conditionWidthPx = ref<number>(
  clampDrawerBaseWidth(
    getNumberPref("conditionBoxWidthPx", CONDITION_BASE_MIN_WIDTH),
    CONDITION_BASE_MIN_WIDTH
  )
);

const routerWidthPx = ref<number>(
  clampDrawerBaseWidth(
    getNumberPref("routerBoxWidthPx", ROUTER_BASE_MIN_WIDTH),
    ROUTER_BASE_MIN_WIDTH
  )
);

const wizardWidthPx = ref<number>(
  clampWizardBaseWidth(getNumberPref("wizardBoxWidthPx", WIZARD_BASE_MIN_WIDTH))
);

const editStepBoxRef = ref<HTMLElement | null>(null);

const infoBoxRef = ref<HTMLElement | null>(null);

const conditionBoxRef = ref<HTMLElement | null>(null);

const routerBoxRef = ref<HTMLElement | null>(null);

const userVarsBoxRef = ref<HTMLElement | null>(null);

const wizardBoxRef = ref<HTMLElement | null>(null);

const currentWizardWidthPx = computed(() =>
  Math.round(
    clampWizardBaseWidth(wizardWidthPx.value) +
      (wizardHistoryVisible.value ? WIZARD_HISTORY_DRAWER_WIDTH : 0)
  )
);

const minWizardWidth = computed<number>(
  () =>
    WIZARD_BASE_MIN_WIDTH +
    (wizardHistoryVisible.value ? WIZARD_HISTORY_DRAWER_WIDTH : 0)
);

const isNameNearLimit = computed(() => {
  if (flow.value?.name?.includes("CLONE")) {
    return flow.value?.name?.length > clonedFlowCharLimit.value;
  }
  return flow.value?.name?.length > charLimit.value;
});

const isDescriptionNearLimit = computed(
  () => flow.value?.description?.length > currentCharLimit.value
);

const outputLogs = ref([]);

const processLogs = ref();

const flowStatus = ref("");

const runFlowDialog = ref(false);

const activeTab = ref(1);

const statusClient = ref();

const infoVisible = ref(true);

const userVariableVisible = ref(false);

const configurationVisible = ref(false);

const isSpecialCharEntered = ref(false);

const defaultProps = {
  children: "children",
  label: "label",
};

const filterText = ref("");

const treeSource = ref("");

const treeRef = ref<InstanceType<typeof ElTree>>();

const handleInputFocus = (data) => {
  if (!data.lastSavedValue) {
    data.lastSavedValue = data.inputValue;
  }
};

function handleInputChange(data) {
  updatedConfigurations.value[data.label] = {
    ...updatedConfigurations.value[data.inputValue],
    ...data,
  };
}

async function submitConfigChanges() {
  const updatePromises = Object.values(updatedConfigurations.value).map(
    (data) => updateConfigurationFrameworkValue(data, flow.value.id)
  );
  await Promise.all(updatePromises);
  updatedConfigurations.value = {};
}

function handleInputValueChange(data, value) {
  data.inputValue = value;
  if (treeSource.value === "exec") {
    pendingData.value = {
      deleted: false,
      key: data.label,
      level: data.level,
      description: data.description,
      value,
      type: data.type,
      children: [],
      ownerId: data.id,
      enumerationValues: data.enumerationValues,
    };
  }
  if (treeSource.value === "config") {
    handleInputChange(data);
  }
}
function isTextLong(description) {
  return description && description.length > 20;
}
async function updateConfigurationFrameworkValue(data, ownerId) {
  configResponseLoading.value = true;
  try {
    await updateConfigurationFramework(data, ownerId);
    getConfigurationVariables();
  } catch (error) {
    showAlert(TYPE.ERROR, t("Flow.ValueUpdatedError"));
  } finally {
    configResponseLoading.value = false;
  }
}
async function submitExecSwitch() {
  configResponseLoading.value = true;
  try {
    await updateConfiguraitonSettings(pendingData.value);
    getConfigurationVariables();
  } catch (error) {
    showAlert(TYPE.ERROR, t("Flow.ValueUpdatedError"));
  } finally {
    configResponseLoading.value = false;
  }
}

watch(filterText, (val) => {
  const tree = treeRef.value;
  if (tree) tree.filter(val);
});

const filterNode = (value, data) => {
  if (!value) return true;
  const labelMatch = data.label.toLowerCase().includes(value.toLowerCase());
  const valueMatch = data.inputValue
    .toLowerCase()
    .includes(value.toLowerCase());
  return labelMatch || valueMatch;
};
const tree = ref([]);
const hasConfigurationData = computed(() => tree.value.length > 0);

watch(
  () => tree.value.length,
  (length) => {
    if (length === 0) {
      configurationVisible.value = false;
    }
  }
);

const conditionVisible = ref(false);

const delayVisible = ref(false);

const cronEditorVisible = ref(false);

const shortCutPressed = ref(false);
const isSubmitting = ref(false);

const contextMenuVisible = ref(false);

const contextMenuIndex = ref(-1);

const contextMenuStep = ref(null);

const contextMenuLeft = ref(0);

const contextMenuTop = ref(0);

const routerVisible = ref(false);

const scrollContainer = ref<HTMLElement>();

const updatedByName = ref("");

const createdByName = ref("");

const createdById = ref("");

const createdAtDate = ref("");

const routerListIndex = ref("");

const editStepRef = ref();

const isStepNameExceedingCharLimit = ref(false);

const detailsSize = ref(
  getPreferenceValue("detailsBoxSize")
    ? getSizeByString(getPreferenceValue("detailsBoxSize"))
    : 0
);

const editStepSize = ref(
  getPreferenceValue("editStepBoxSize")
    ? getSizeByString(getPreferenceValue("editStepBoxSize"))
    : 1
);

const filterSize = ref(
  getPreferenceValue("filterBoxSize")
    ? getSizeByString(getPreferenceValue("filterBoxSize"))
    : 2
);

const routerSize = ref(
  getPreferenceValue("conditionBoxSize")
    ? getSizeByString(getPreferenceValue("conditionBoxSize"))
    : 2
);

const isAnyChange = ref(false);
const isGenerating = ref(false);
const isRetrieving = ref(false);
const selectedReportFormat = ref("pdf");
const reportExists = ref(false);
const reportFlowVersion = ref<number | null>(null);
const isPdfReady = ref(false);
const isReportUpToDate = computed(
  () =>
    reportExists.value &&
    !isAnyChange.value &&
    reportFlowVersion.value !== null &&
    reportFlowVersion.value === flow.value?.version
);
const showAIReportSection = ref(false);

const aiSkillGeneratorEnabled = ref(false);
const skillGenerationEnabled = computed(() =>
  isSkillGenerationEnabled(flow.value?.skillGenerationEnabled)
);
const skillGenerationEnabledModel = computed({
  get: () => isSkillGenerationEnabled(flow.value?.skillGenerationEnabled),
  set: (val: boolean) => {
    if (flow.value) flow.value.skillGenerationEnabled = val;
    if (flowId.value) {
      saveSkillGenerationToggle(flowId.value, val);
    }
    onFlowChange();
  },
});
const isGeneratingSkill = ref(false);
const skillExists = ref(false);
const skillFlowVersion = ref<number | null>(null);
const isSkillUpToDate = computed(
  () =>
    skillExists.value &&
    skillFlowVersion.value !== null &&
    Number(skillFlowVersion.value) === Number(flow.value?.version) &&
    !isAnyChange.value
);

const checkReportStatus = async () => {
  const activeFlowId = flow.value?.id;
  const activeFlowVersion = flow.value?.version;
  reportExists.value = false;
  reportFlowVersion.value = null;
  isPdfReady.value = false;
  showAIReportSection.value = false;

  const tenantId = authInfo.value?.tenantId;
  if (!tenantId || !(await isAIFlowReportingEnabledForTenant(tenantId))) {
    return;
  }

  if (
    flow.value?.id !== activeFlowId ||
    flow.value?.version !== activeFlowVersion
  ) {
    return;
  }

  showAIReportSection.value = true;
  if (activeFlowId) {
    const {
      exists,
      reportFlowVersion: fetchedVersion,
      pdfReady,
    } = await checkAIReportExists(activeFlowId);

    if (
      flow.value?.id !== activeFlowId ||
      flow.value?.version !== activeFlowVersion
    ) {
      return;
    }

    reportExists.value = exists;
    reportFlowVersion.value = fetchedVersion;
    isPdfReady.value = pdfReady;
  } else {
    // Flow ID not found, check skipped
  }
};

async function refreshReportStatus(targetFlowId: string) {
  const {
    exists,
    reportFlowVersion: fetchedVersion,
    pdfReady,
  } = await checkAIReportExists(targetFlowId);

  if (targetFlowId !== flow.value?.id) return;

  reportExists.value = exists;
  reportFlowVersion.value = fetchedVersion;
  isPdfReady.value = pdfReady;
}

async function listenForReportUpdates(
  requestId: string,
  isUpdate: boolean,
  targetFlowId: string
) {
  if (!requestId) return;

  const subscribeToTopic = () => {
    const statusTopic = WebsocketUrlProvider.ReportTopic();

    reportClient.subscribe(statusTopic, async (msg) => {
      try {
        if (!msg.body) return;

        const data = JSON.parse(msg.body);

        if (data.requestId !== requestId) {
          return;
        }

        if (data.status === "processing") {
          isGenerating.value = true;
        } else if (data.status === "completed") {
          isGenerating.value = false;
          const successMessageKey = isUpdate
            ? "Flow.ReportUpdatedSuccess"
            : "Flow.ReportGeneratedSuccess";
          showAlert(TYPE.SUCCESS, t(successMessageKey));
          await refreshReportStatus(targetFlowId);
        } else if (
          data.status === "pdf_ready" &&
          data.flowId === targetFlowId &&
          targetFlowId === flow.value?.id
        ) {
          isPdfReady.value = true;
        } else if (data.status === "failed") {
          isGenerating.value = false;
          showAlert(
            TYPE.ERROR,
            t("Flow.ReportStatusError", {
              message: data.message || t("Flow.UnknownError"),
            })
          );
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    });
  };

  if (!reportClient || !reportClient.connected) {
    try {
      const stompClient = await connectWebsocket();
      reportClient = stompClient;
      reportClient.debug = (f) => f;

      const headers = {
        host: "/",
      };

      reportClient.connect(
        headers,
        () => {
          subscribeToTopic();
        },
        () => {
          isGenerating.value = false;
          showAlert(TYPE.ERROR, t("Flow.WebSocketConnectionFailed"));
        }
      );
    } catch (e) {
      isGenerating.value = false;
      showAlert(TYPE.ERROR, t("Flow.WebSocketConnectionError"));
    }
  } else {
    subscribeToTopic();
  }
}

async function generateOrUpdateReport(isUpdate: boolean) {
  if (!flow.value || !flow.value.id) {
    showAlert(TYPE.WARNING, t("Flow.FlowMustBeSavedBeforeReport"));
    return;
  }

  const targetFlowId = flow.value.id;
  isGenerating.value = true;
  try {
    const flowDataToSend = cloneDeep(flow.value);
    flowDataToSend.steps = useAddPositionToStep(filterSteps(steps.value));

    let response;

    if (isUpdate) {
      response = await updateAIReport(targetFlowId, flowDataToSend);
    } else {
      response = await generateAIReport(flowDataToSend);
    }

    if (response?.apiError !== undefined) {
      const code = response.apiError;
      let msg: string;
      if (code === 401) {
        msg = t("Flow.SessionExpired");
      } else if (code === 403) {
        msg = t("Flow.PermissionDenied");
      } else if (code === 500) {
        msg = t("Flow.ServerError");
      } else if (isUpdate) {
        msg = t("Flow.ReportUpdateFailed");
      } else {
        msg = t("Flow.ReportGenerateFailed");
      }
      showAlert(TYPE.ERROR, msg);
      isGenerating.value = false;
      return;
    }

    if (response && response.requestId) {
      listenForReportUpdates(response.requestId, isUpdate, targetFlowId);
    } else {
      isGenerating.value = false;
      if (response) {
        const successMessageKey = isUpdate
          ? "Flow.ReportUpdatedSuccess"
          : "Flow.ReportGeneratedSuccess";
        showAlert(TYPE.SUCCESS, t(successMessageKey));
        await refreshReportStatus(targetFlowId);
      }
    }
  } catch (error) {
    const errorMessageKey = isUpdate
      ? "Flow.ReportUpdateError"
      : "Flow.ReportGenerationError";
    showAlert(TYPE.ERROR, t(errorMessageKey));
    isGenerating.value = false;
  }
}

async function onGenerateReport() {
  await generateOrUpdateReport(false);
}
async function onUpdateReport() {
  await generateOrUpdateReport(true);
}
async function onRetrieveReport() {
  if (!flowId.value) {
    showAlert(TYPE.ERROR, t("Flow.FlowIdNotFound"));
    return;
  }

  if (selectedReportFormat.value === "pdf" && !isPdfReady.value) {
    showAlert(TYPE.WARNING, t("Flow.PdfStillRendering"));
    return;
  }

  isRetrieving.value = true;
  try {
    const success = await getAIReport(flowId.value, selectedReportFormat.value);
    if (success) {
      showAlert(TYPE.SUCCESS, t("Flow.ReportDownloadedSuccess"));
    } else {
      showAlert(TYPE.ERROR, t("Flow.ReportDownloadFailed"));
    }
  } catch (error) {
    console.error(error);
    showAlert(TYPE.ERROR, t("Flow.ReportDownloadError"));
  } finally {
    isRetrieving.value = false;
  }
}

async function resumeSkillStatus() {
  const currentFlowId = flowId.value;
  const currentFlowVersion =
    flow.value?.version != null ? Number(flow.value.version) : null;
  if (
    !currentFlowId ||
    currentFlowVersion == null ||
    Number.isNaN(currentFlowVersion)
  ) {
    return;
  }
  try {
    if (skillPollInterval !== null) {
      clearInterval(skillPollInterval);
      skillPollInterval = null;
    }
    const pending = getPersistedSkillGenJob(currentFlowId, currentFlowVersion);
    const flowVersionForStatus = pending?.flowVersion ?? currentFlowVersion;
    if (flowVersionForStatus !== currentFlowVersion) return;
    const isActiveFlowVersion = () =>
      flowId.value === currentFlowId &&
      flow.value?.version != null &&
      Number(flow.value.version) === currentFlowVersion;
    let trackedJobId = pending?.jobId;
    if (!pending) {
      const status = await getFlowSkillStatus(
        currentFlowId,
        flowVersionForStatus
      );
      if (!isActiveFlowVersion()) return;
      skillExists.value = status.exists;
      skillFlowVersion.value = status.flowVersion;
      isGeneratingSkill.value = status.status === "processing";
      trackedJobId = status?.jobId || undefined;
      if (status?.status !== "processing") return;
    }
    // Check if the backend already finished while the user was away
    const status = await getFlowSkillStatus(
      currentFlowId,
      flowVersionForStatus,
      trackedJobId
    );
    if (!isActiveFlowVersion()) return;
    trackedJobId = trackedJobId || status.jobId || undefined;
    if (status.status === "error") {
      isGeneratingSkill.value = false;
      clearSkillGenJob(currentFlowId, flowVersionForStatus);
      showAlert(TYPE.ERROR, t("Flow.SkillGenerationFailed"));
      return;
    }
    if (
      status.status === "completed" ||
      (!trackedJobId && status.exists && status.status !== "processing")
    ) {
      skillExists.value = true;
      skillFlowVersion.value = status.flowVersion ?? flowVersionForStatus;
      isGeneratingSkill.value = false;
      clearSkillGenJob(currentFlowId, flowVersionForStatus);
      return;
    }
    // Still in progress — show generating and poll Qdrant every 15 s
    isGeneratingSkill.value = true;
    const pollStart = Date.now();
    let pollInterval: ReturnType<typeof setInterval> | null = null;
    const stopThisPoller = () => {
      if (pollInterval === null) return;
      clearInterval(pollInterval);
      if (skillPollInterval === pollInterval) {
        skillPollInterval = null;
      }
      pollInterval = null;
    };
    pollInterval = setInterval(async () => {
      if (!isActiveFlowVersion()) {
        stopThisPoller();
        return;
      }
      if (Date.now() - pollStart > skillGenPollTimeoutMs) {
        stopThisPoller();
        clearSkillGenJob(currentFlowId, flowVersionForStatus);
        isGeneratingSkill.value = false;
        showAlert(TYPE.ERROR, t("Flow.SkillGenerationFailed"));
        return;
      }
      try {
        const s = await getFlowSkillStatus(
          currentFlowId,
          flowVersionForStatus,
          trackedJobId
        );
        if (!isActiveFlowVersion()) {
          stopThisPoller();
          return;
        }
        if (s.status === "error") {
          stopThisPoller();
          clearSkillGenJob(currentFlowId, flowVersionForStatus);
          isGeneratingSkill.value = false;
          showAlert(TYPE.ERROR, t("Flow.SkillGenerationFailed"));
        } else if (
          s.status === "completed" ||
          (!trackedJobId && s.exists && s.status !== "processing")
        ) {
          stopThisPoller();
          clearSkillGenJob(currentFlowId, flowVersionForStatus);
          skillExists.value = true;
          skillFlowVersion.value = s.flowVersion ?? flowVersionForStatus;
          isGeneratingSkill.value = false;
          showAlert(TYPE.SUCCESS, t("Flow.SkillGeneratedSuccess"));
        }
      } catch {
        // Keep polling on transient status failures.
      }
    }, skillGenPollIntervalMs);
    skillPollInterval = pollInterval;
  } catch (error) {
    isGeneratingSkill.value = false;
    console.warn("Failed to refresh skill generation status.", error);
  }
}

async function waitForSkillJobCompletion(jobId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    connectWebsocket()
      .then((stompClient) => {
        skillClient = stompClient;
        stompClient.connect(
          { host: "/" },
          () => {
            const sub = stompClient.subscribe("/wizard", (msg: any) => {
              const data = JSON.parse(msg.body);
              if (data.sessionId !== jobId) return;
              if (data.status === "completed") {
                sub.unsubscribe();
                stompClient.disconnect();
                skillClient = undefined;
                resolve();
              } else if (data.status === "error") {
                sub.unsubscribe();
                stompClient.disconnect();
                skillClient = undefined;
                reject(new Error(data.message));
              }
            });
          },
          (_error) => {
            skillClient = undefined;
            reject(new Error("WebSocket connection failed"));
          }
        );
      })
      .catch(reject);
  });
}

async function onGenerateSkill() {
  if (isGeneratingSkill.value) return;
  if (!flowId.value || flow.value?.version == null) {
    showAlert(TYPE.WARNING, t("Flow.FlowNotSaved"));
    return;
  }
  if (isAnyChange.value) {
    showAlert(TYPE.WARNING, t("Flow.UnsavedChanges"));
    return;
  }
  const generationFlowVersion = Number(flow.value.version);
  isGeneratingSkill.value = true;
  let keepGenerating = false;
  let jobId: string | undefined;
  try {
    const rawFlow = await getFlow(flowId.value, String(flow.value.version));
    if (!rawFlow) {
      throw new Error("Failed to load the saved flow for skill generation");
    }
    const { jobId: generatedJobId } = await generateFlowSkill(
      { result: [rawFlow] },
      flowId.value,
      generationFlowVersion,
      skillGenerationEnabled.value
    );
    jobId = generatedJobId;
    persistSkillGenJob(flowId.value, generatedJobId, generationFlowVersion);
    resumeSkillStatus();
    await waitForSkillJobCompletion(generatedJobId);
    if (skillPollInterval !== null) {
      clearInterval(skillPollInterval);
      skillPollInterval = null;
    }
    if (isGeneratingSkill.value || !skillExists.value) {
      skillExists.value = true;
      skillFlowVersion.value = generationFlowVersion;
      clearSkillGenJob(flowId.value, generationFlowVersion);
      showAlert(TYPE.SUCCESS, t("Flow.SkillGeneratedSuccess"));
    }
  } catch (error) {
    const status =
      flowId.value && jobId
        ? await getFlowSkillStatus(
            flowId.value,
            flow.value?.version != null ? Number(flow.value.version) : null,
            jobId
          )
        : null;
    keepGenerating = status?.status === "processing";
    if (status?.status === "error")
      clearSkillGenJob(flowId.value, generationFlowVersion);
    if (keepGenerating) resumeSkillStatus();
    if (!keepGenerating) {
      showAlert(
        TYPE.ERROR,
        error instanceof Error && error.message
          ? error.message
          : t("Flow.SkillGenerationFailed")
      );
    }
  } finally {
    if (!keepGenerating) isGeneratingSkill.value = false;
  }
}

watch(
  () => EventBus.isAnyChange,
  (newVal) => {
    isAnyChange.value = newVal;
  }
);

watch(
  () => steps.value,
  () => {
    const positioned = useAddPositionToStep(steps.value);
    outputList.value = getOutputListForAllStep(positioned, {
      skipPositioning: true,
    });
    metaoutputList.value = getMetaoutputListForAllStep(positioned, {
      skipPositioning: true,
    });
  },
  { deep: true, immediate: true }
);

const tabList = ref([
  {
    tab: 2,
    name: "Versions",
    icon: "layer-group",
    tooltip: t("Flow.Versions"),
  },
  {
    tab: 3,
    name: "Activities",
    icon: "history",
    tooltip: t("Common.Activities"),
  },
]);

const charLimit = ref(200);
const clonedFlowCharLimit = ref(250);

const currentCharLimit = computed(() => {
  if (flow.value && flow.value.name) {
    return flow.value.name.includes("CLONE")
      ? clonedFlowCharLimit.value
      : charLimit.value;
  }
  return charLimit.value;
});

const invalidEmail = ref("");
const flowLineWrapper = ref<HTMLElement>();
const loopLineWrapper = ref<HTMLElement>();
const isMouseDown = ref(false);
const isStepBoxClicked = ref(false);
const customStopPropagation = ref(false);
const dragScrollActive = ref(false);
const nameInputField = ref<HTMLElement>(null);
const activityId = ref("");
const zoomScale = ref(50);
const userDefinedVariables = ref([]);
let client;
let reportClient;
let skillClient;
let skillPollInterval: ReturnType<typeof setInterval> | null = null;
let startX;
let startY;
let scrollLeft;
let scrollTop;

const zoom = (data) => {
  const containerElement = document.querySelector("#left-step-container");
  containerElement.style.transform = `scale(${data + 50}%)`;
  containerElement.style.transformOrigin = "0 0";
};

onMounted(async () => {
  pageLoading.value = true;

  const tenantId = authInfo.value?.tenantId;
  if (tenantId) {
    aiWizardEnabled.value = await isAIWizardEnabledForTenant(tenantId);
    aiSkillGeneratorEnabled.value = await isAISkillGeneratorEnabledForTenant(
      tenantId
    );
  }

  const [pollIntervalRaw, pollTimeoutRaw] = await Promise.all([
    getProperty("ai.skill-generator.poll-interval-ms"),
    getProperty("ai.skill-generator.poll-timeout-ms"),
  ]);
  const parsedInterval = Number(pollIntervalRaw);
  const parsedTimeout = Number(pollTimeoutRaw);
  if (pollIntervalRaw && !Number.isNaN(parsedInterval) && parsedInterval > 0)
    skillGenPollIntervalMs = parsedInterval;
  if (pollTimeoutRaw && !Number.isNaN(parsedTimeout) && parsedTimeout > 0)
    skillGenPollTimeoutMs = parsedTimeout;

  const shouldRestoreWizard = consumeWizardReopenAfterRefresh();

  if (flowId.value && version.value) {
    initializeWizardSessionScope(
      `flow:${flowId.value}:${version.value}`,
      shouldRestoreWizard
    );
  } else {
    if (!shouldRestoreWizard) {
      resetPersistedWizardSession();
    }
    initializeWizardSessionScope("create-flow", shouldRestoreWizard);
  }

  try {
    connections.value = await getConnections();
    try {
      connectors.value = await getOrganizationsConnectorList();
    } catch (connectorErr) {
      // The connector list is non-critical for loading the flow; a failed fetch must not abort
      // flow/step initialization. Degrade to the empty default and continue.
      console.log("failed to load organization connector list");
    }
    nameInputField.value.focus();
    // If editing flow instead of creating
    if (flowId.value && version.value) {
      await getSelectedFlow();
      isAnyChange.value = false;
      EventBus.isAnyChange = false;
      checkReportStatus();
      if (aiSkillGeneratorEnabled.value) resumeSkillStatus();
    } else {
      addStep();
    }

    window.addEventListener("keydown", saveShortCut);
    window.addEventListener("keyup", () => {
      shortCutPressed.value = false;
    });
  } catch (e) {
    console.log("has error when page was loading");
  }
  pageLoading.value = false;
  if (shouldRestoreWizard) {
    await nextTick();
    openWizardDrawer();
  }
  setTimeout(() => isLineCreated(), 100);
});

const expressions = ref([]);
async function getExpressions() {
  await getExpressionDetails().then((response) => {
    expressions.value = response;
  });
}

const isNewUiEnabled = ref(false);

onMounted(async () => {
  await getSysVariables();
  await getExpressions();
  await fetchExecutionList();
  await getConfigurationVariables();
  await checkNewUiEnabled();
});

onBeforeUnmount(() => {
  if (pendingSyncRafId) cancelAnimationFrame(pendingSyncRafId);
  window.removeEventListener("keydown", saveShortCut);
  removeLeaderLines(flowLineWrapper.value, null);
  if (client) {
    client.disconnect();
  }
});

async function checkNewUiEnabled() {
  try {
    const tenantId = authInfo.value?.tenantId;
    if (!tenantId) {
      isNewUiEnabled.value = false;
      return;
    }

    isNewUiEnabled.value = await isNewUiEnabledForTenant(tenantId);
  } catch (error) {
    console.error("isNewUiEnabledForTenant error:", error);
    isNewUiEnabled.value = false;
  }
}

const executionList = ref([]);
const defaultExecution = ref([]);
const selectedExecution = ref(null);
const tenantDefaultExecution = ref([]);

async function fetchExecutionList() {
  try {
    const executions = await getOrganizationsExecutions(
      authInfo.value.organizationId
    );
    tenantDefaultExecution.value = await getTenantDefault(
      authInfo.value.tenantId
    );
    const organizationDefaultExecution = await getOrganizationDefault(
      authInfo.value.organizationId
    );
    if (organizationDefaultExecution) {
      defaultExecution.value = organizationDefaultExecution[0]?.execution?.id;
    } else if (tenantDefaultExecution.value) {
      defaultExecution.value = tenantDefaultExecution.value[0]?.execution?.id;
    }
    executionList.value = executions || [];
    const flowExecutionExists =
      executions?.some((exe) => {
        const exeId = exe?.id ?? null;
        const flowExecutionId = flow?.value?.execution?.id ?? null;
        return (
          exeId !== null &&
          flowExecutionId !== null &&
          exeId === flowExecutionId
        );
      }) ?? false;
    if (!flowExecutionExists && defaultExecution.value) {
      selectedExecution.value = defaultExecution.value;
      handleExecutionChange(defaultExecution.value);
    }
  } catch (error) {
    console.error("Failed to fetch execution list:", error);
    showAlert(TYPE.ERROR, t("Common.ExecutionFetchError"));
  }
}
function getLogoSrc(selectedId) {
  const selected = executionList.value.find((item) => item.id === selectedId);
  if (selected) {
    const typeFormatted = selected.type;
    return `${ASSETS_BASE_URL}/${typeFormatted}${getResolution(false)}.png`;
  }
  return `${ASSETS_BASE_URL}/default-logo.png`;
}

function handleExecutionChange(selectedExecutionId) {
  const selectedExecutionObj = executionList.value.find(
    (execution) => execution.id === selectedExecutionId
  );
  if (selectedExecutionObj) {
    flow.value.execution = selectedExecutionObj;
  }
}

watch(
  () => flow.value.execution,
  (newExec) => {
    if (newExec) {
      selectedExecution.value = flow.value.execution.id || null;
    }
  },
  { immediate: true }
);

const udvErrors = ref([]);
const { getStepDisplayNumber } = useStepDisplay();

function getUdvErrorKey(event) {
  if (event?.stepNumber) return `stepNumber:${event.stepNumber}`;
  if (event?.origId) return `origId:${event.origId}`;
  if (event?.id) return `id:${event.id}`;
  if (event?.uniqueId !== undefined && event?.uniqueId !== null) {
    return `uniqueId:${event.uniqueId}`;
  }
  return `index:${event?.index}`;
}

function getUdvErrorStepNumber(err) {
  let positionalIndex = 0;
  if (typeof err?.index === "number") {
    positionalIndex = err.index;
  } else if (typeof err?.ix === "number") {
    positionalIndex = err.ix;
  }
  return getStepDisplayNumber(positionalIndex, err?.stepNumber);
}

function handleUdvError(event) {
  const key = getUdvErrorKey(event);
  const nextEvent = { ...event, key };
  const index = udvErrors.value.findIndex((err) => err.key === key);
  if (index !== -1) {
    udvErrors.value[index] = nextEvent;
  } else {
    udvErrors.value.push(nextEvent);
  }
}
function addUserDefinedVariables() {
  const item = ref({ itemKey: "", itemValue: "" });
  userDefinedVariables.value.push(item);
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
}
function preventLetters(event) {
  const allowedChars = /^[a-zA-Z0-9]*$/;
  if (
    !allowedChars.test(event.key) &&
    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(event.key)
  ) {
    event.preventDefault();
  }
}
function updateUserDefinedVariables(e, key, index) {
  let val = e;
  const allowedChars = /^[a-zA-Z0-9]*$/;
  if (
    key === "itemKey" &&
    !allowedChars.test(e) &&
    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e)
  ) {
    showAlert(TYPE.WARNING, t("Flow.KeyIncluedSpecialChar"));
    isSpecialCharEntered.value = true;
    val = "";
    return;
  }
  if (
    key === "itemKey" &&
    userDefinedVariables.value.some((item) => item.itemKey === e)
  ) {
    showAlert(TYPE.WARNING, t("Flow.KeyIsAlreadyExist"));
  }
  userDefinedVariables.value[index][key] = val;
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
  isSpecialCharEntered.value = false;
}
async function removeUserDefinedVariables(index: number) {
  const udv = userDefinedVariables.value[index];
  const key = udv.value.itemKey;
  if (!key) {
    userDefinedVariables.value.splice(index, 1);
    isAnyChange.value = true;
    return;
  }
  const removed = await confirmAndRemoveUdv(
    key,
    index,
    userDefinedVariables.value,
    steps.value,
    t
  );
  if (removed) {
    isAnyChange.value = true;
    EventBus.isAnyChange = true;
  }
}

function isDuplicateKeys() {
  const itemKeys = [];

  userDefinedVariables.value.forEach((item) => {
    itemKeys.push(item.value.itemKey);
  });

  const duplicates = itemKeys.reduce((acc, curr, index, self) => {
    if (self.indexOf(curr) !== index && !acc.includes(curr)) {
      acc.push(curr);
    }
    return acc;
  }, []);

  return duplicates.length > 0;
}

function formatUserDefinedVariables() {
  const formattedObj = {};

  userDefinedVariables.value.forEach((item) => {
    if (item.value.itemKey && item.value.itemKey.trim() !== "") {
      let value = "";
      try {
        value = JSON.parse(item.value.itemValue);
      } catch (error) {
        value = item.value.itemValue;
      }
      formattedObj[item.value.itemKey] = value;
    }
  });

  return formattedObj;
}
function parseUserDefinedVariables(userDefVar) {
  if (userDefVar === undefined || userDefVar === null) return;
  const userDefVarArr = Object.entries(userDefVar);
  userDefinedVariables.value = [];

  userDefVarArr.forEach(([key, value]) => {
    const parsedValue =
      typeof value === "string" ? value : JSON.stringify(value);
    const itemObj = ref({
      itemKey: key,
      itemValue: parsedValue,
    });
    userDefinedVariables.value.push(itemObj);
  });
}

function getSizeByValue(size) {
  switch (size) {
    case 0:
      return "small";
    case 1:
      return "medium";
    case 2:
      return "large";
    default:
      return "medium";
  }
}

function getSizeByString(size) {
  switch (size) {
    case "small":
      return 0;
    case "medium":
      return 1;
    case "large":
      return 2;
    default:
      return 1;
  }
}

function contextMenuEvt(event, index, step) {
  event.preventDefault();
  if (contextMenuVisible.value) {
    closeContextMenu();
  } else {
    contextMenuLeft.value = event.x;
    contextMenuTop.value = event.y;
    contextMenuIndex.value = index;
    contextMenuStep.value = step;
    contextMenuVisible.value = true;
  }
}

function closeContextMenu() {
  contextMenuVisible.value = false;
  contextMenuIndex.value = -1;
  contextMenuStep.value = null;
}

function changeFilter(filter) {
  if (selectedStep.value) {
    updateStepsFilter(steps.value, filter, selectedStep.value);
  }
}

async function removeFilter() {
  const isConfirmed = await showConfirm(
    "warning",
    t("Common.DeleteFilter"),
    t("Common.DeleteFilterMessage")
  );

  if (!isConfirmed) {
    return;
  }

  changeFilter([]);
  updateStep(true);
  showCondition();
}

function changeDelay(delay) {
  if (selectedStep.value) {
    updateStepsDelay(steps.value, delay, selectedStep.value);
  }
}

function saveShortCut(event) {
  if (activeTab.value === 1) {
    if (!(event.keyCode === 83 && (event.ctrlKey || event.metaKey))) {
      return;
    }
    event.preventDefault();
    if (!shortCutPressed.value && !responseLoading.value) {
      shortCutPressed.value = true;
      if (flowId.value && !flow.value.latest) {
        flowRevert();
      } else {
        onFlowSubmit();
      }
    }
  }
}
const expressionDrawer = ref(false);

watch(
  () => functionsVisible.value,
  (visible) => {
    if (!visible) {
      expressionDrawer.value = false;
    }
  }
);

function changeFunctionsVisible(val) {
  functionsVisible.value = val;
}

function updateCronExpr(type, schedule, timeZone) {
  flow.value.scheduleType = type;
  flow.value.schedule = schedule;
  // Java normalized against this zone, so it is the flow's canonical one.
  flow.value.timeZone = timeZone;
  fetchTimezone();
}

function handleScheduleTypeChange() {
  selectedOffset.value = null;
  flow.value.timeZone = undefined;
  nextRunTime.value = "";
}
// Lets the save path settle a debounced schedule normalization before persisting.
const cronEditorRef = ref<{
  flushSchedule: () => Promise<boolean>;
  scheduleError: string;
} | null>(null);
function setEditorVisible(val) {
  cronEditorVisible.value = val;
}
async function onEnableNewUi() {
  if (!flowId.value || !version.value) {
    showAlert(TYPE.WARNING, t("Flow.FlowNotSaved"));
    return;
  }

  const isConfirmed = await showConfirm(
    "warning",
    t("Flow.SwitchToNewUiTitle"),
    t("Flow.SwitchToNewUiMessage")
  );

  if (!isConfirmed) return;

  responseLoading.value = true;
  try {
    const response = await convertFlowToNewUi(flowId.value, version.value);
    if (response) {
      showAlert(TYPE.SUCCESS, t("Flow.MigratedToNewUI"));
      isVersionChanged.value = true;
      await router.push({
        name: "editFlowsRouteNew",
        params: {
          id: response.id || flowId.value,
          version: response.version || version.value,
        },
        query: { migrated: "true" },
      });
    }
  } catch (e) {
    showAlert(TYPE.ERROR, e.message ?? t("Flow.MigrationError"));
  } finally {
    responseLoading.value = false;
  }
}

function showCondition(index?, step?) {
  if (index === undefined && step === undefined) {
    conditionVisible.value = false;
    selectedStep.value = null;
    selectedIndex.value = undefined;
    resetAutoScrollPadding();
    return;
  }

  drawerVisible.value = false;
  wizardDrawerVisible.value = false;
  delayVisible.value = false;
  infoVisible.value = false;
  userVariableVisible.value = false;
  configurationVisible.value = false;
  routerVisible.value = false;
  functionsVisible.value = false;

  if (step && !step.filter) {
    step.filter = [];
  }

  if (conditionVisible.value && selectedStep.value?.id === step?.id) {
    conditionVisible.value = false;
    selectedStep.value = null;
    selectedIndex.value = undefined;
    resetAutoScrollPadding();
    return;
  }

  if (conditionVisible.value) {
    conditionVisible.value = false;
    nextTick(() => {
      selectedStep.value = step!;
      selectedIndex.value = index!;
      conditionVisible.value = true;
      autoScrollStepElement(`step-id-${step.id}`);
    });
  } else {
    selectedStep.value = step!;
    selectedIndex.value = index!;
    conditionVisible.value = true;
    autoScrollStepElement(`step-id-${step.id}`);
  }
}
function openDelay(index?, step?) {
  if (delayVisible.value) {
    selectedIndex.value = -1;
    selectedStep.value = null;
    functionsVisible.value = false;
    delayVisible.value = !delayVisible.value;
  } else {
    drawerVisible.value = false;
    infoVisible.value = false;
    wizardDrawerVisible.value = false;
    configurationVisible.value = false;
    userVariableVisible.value = false;
    conditionVisible.value = false;
    routerVisible.value = false;
    selectedIndex.value = index;
    selectedStep.value = step;
    delayVisible.value = !delayVisible.value;
  }
}

const showingStepOutputData = reactive({ output: undefined, index: 0 });
const visibleOutputDailog = ref(false);
function openOutput(index?, step?) {
  if (visibleOutputDailog.value) {
    visibleOutputDailog.value = false;
    showingStepOutputData.output = "";
  }
  setTimeout(() => {
    showingStepOutputData.output = JSON.parse(JSON.stringify(step)).output;
    showingStepOutputData.index = JSON.parse(JSON.stringify(step)).index;
    visibleOutputDailog.value = true;
  }, 10);
}

function setActive(tab) {
  infoVisible.value = false;
  wizardDrawerVisible.value = false;
  userVariableVisible.value = false;
  configurationVisible.value = false;
  selectedStep.value = undefined;
  selectedIndex.value = undefined;
  drawerVisible.value = false;
  conditionVisible.value = false;
  functionsVisible.value = false;
  delayVisible.value = false;

  activeTab.value = tab;
}

function setActiveOne() {
  activeTab.value = 1;
  nextTick(() => {
    resetStepLines();
  });
}
function showUserVariables() {
  if (userVariableVisible.value) {
    userVariableVisible.value = false;
  } else {
    closeDrawer();
    wizardDrawerVisible.value = false;
    conditionVisible.value = false;
    delayVisible.value = false;
    routerVisible.value = false;
    infoVisible.value = false;
    configurationVisible.value = false;
    if (activeTab.value !== 1) {
      activeTab.value = 1;
      resetStepLines();
    }
    userVariableVisible.value = true;
  }
}
function showConfiguration() {
  if (!hasConfigurationData.value) {
    return;
  }
  if (configurationVisible.value) {
    configurationVisible.value = false;
  } else {
    closeDrawer();
    wizardDrawerVisible.value = false;
    conditionVisible.value = false;
    delayVisible.value = false;
    routerVisible.value = false;
    infoVisible.value = false;
    userVariableVisible.value = false;
    if (activeTab.value !== 1) {
      activeTab.value = 1;
      resetStepLines();
    }
    configurationVisible.value = true;
  }
}
function showInfo() {
  if (infoVisible.value) {
    infoVisible.value = false;
  } else {
    closeDrawer();
    wizardDrawerVisible.value = false;
    userVariableVisible.value = false;
    configurationVisible.value = false;
    conditionVisible.value = false;
    delayVisible.value = false;
    routerVisible.value = false;
    if (activeTab.value !== 1) {
      activeTab.value = 1;
      resetStepLines();
    }
    infoVisible.value = true;
    nextTick(() => nameInputField.value.focus());
  }
}

function setLoading(loading) {
  stepLoading.value = loading;
}

onUnmounted(() => {
  pageOpen.value = false;
  if (statusClient.value) {
    statusClient.value.disconnect();
    statusClient.value = undefined;
  }
  removeLeaderLines(flowLineWrapper.value, null);

  if (reportClient) {
    reportClient.disconnect();
  }
  if (skillClient) {
    skillClient.disconnect();
    skillClient = undefined;
  }
  if (skillPollInterval !== null) {
    clearInterval(skillPollInterval);
    skillPollInterval = null;
  }
});

const editFlowContent = ref<HTMLElement>(null);

async function getSysVariables() {
  await getSystemVariables().then((response) => {
    systemVariables.value = response;
  });
}
function updateSelectedStepByIxIy(stepList, currentStep) {
  if (currentStep) {
    stepList.forEach((step) => {
      if (!step.type) {
        if (
          step?.uniqueId === currentStep?.uniqueId &&
          step.ix === currentStep.ix &&
          step.iy === currentStep.iy
        ) {
          selectedStep.value = { ...step };
        }
      } else {
        step.routes.forEach((items) => {
          updateSelectedStepByIxIy(items.steps, currentStep);
        });
      }
    });
  }
}
async function getConfigurationVariables() {
  if (flowId.value) {
    try {
      const response = await getConfigurationFramework(flowId.value);
      if (response && Array.isArray(response)) {
        const sortByKey = (node) => {
          if (node.children && node.children.length > 0) {
            node.children.sort((a, b) => a.key.localeCompare(b.key));
            node.children.forEach(sortByKey);
          }
        };
        response.forEach(sortByKey);
        tree.value = mapApiDataToTree(response);
        treeSource.value = "config";
      } else if (response && response.code === "404") {
        await fetchExecutionProperties();
      }
    } catch (error) {
      console.error("Error fetching configuration variables:", error);
    }
  }
}

async function fetchExecutionProperties() {
  const executionProperties = await getExecutionProperties();
  if (executionProperties) {
    const treeItem = {
      id: flowId.value,
      label: executionProperties.key,
      level: "FLOW",
      type: "STRING",
      inputValue: executionProperties.defaultValue,
      lastSavedValue: executionProperties.defaultValue,
      description: executionProperties.description,
      children: [],
    };
    pendingData.value = {
      deleted: false,
      key: executionProperties.key,
      level: "FLOW",
      value: executionProperties.defaultValue,
      description: executionProperties.description,
      type: "STRING",
      children: [],
      ownerId: flowId.value,
      enumerationValues: executionProperties.enumerationValues,
    };
    if (executionProperties.enumerationValues.length > 0) {
      treeItem.enumerationValues = executionProperties.enumerationValues;
    }
    tree.value = [treeItem];
    treeSource.value = "exec";
  }
}

function mapApiDataToTree(apiData) {
  return apiData.map((item) => ({
    id: item.ownerId,
    label: item.key,
    description: item.description || "",
    level: item.level,
    type: item.type,
    inputValue: item.value || "",
    lastSavedValue: item.value || "",
    enumerationValues: item.enumerationValues || [],
    children: item.children ? mapApiDataToTree(item.children) : [],
  }));
}

async function getSelectedFlow(
  {
    doNotUpdateFlow = false,
    newFlow = undefined,
  }: { doNotUpdateFlow?: boolean; newFlow?: any } = {
    doNotUpdateFlow: false,
    newFlow: undefined,
  }
) {
  if (flowId.value && version.value) {
    let currentFlow;
    if (!newFlow) {
      currentFlow = await getFlow(flowId.value, version.value);
    } else {
      currentFlow = newFlow;
    }
    if (!doNotUpdateFlow) {
      flow.value = currentFlow;
      if (flowId.value) {
        const stored = restoreSkillGenerationToggle(flowId.value);
        if (stored !== undefined) {
          flow.value.skillGenerationEnabled = stored;
        }
      }
    }
    steps.value = useAddPositionToStep(cloneDeep(currentFlow.steps));
    updateSelectedStepByIxIy(steps.value, selectedStep.value);

    if (currentFlow.modifiedBy != null) {
      updatedByName.value = await getModifiedUser(currentFlow.modifiedBy);
    }

    if (currentFlow != null) {
      createdAtDate.value = await getCreatedAtByFlowIdAndVersion(
        currentFlow.id,
        1
      );
      createdById.value = await getCreatedByByFlowIdAndVersion(
        currentFlow.id,
        1
      );
      createdByName.value = await getUserById(createdById.value);
    }
    parseUserDefinedVariables(flow.value.userDefinedVariables);

    flowStatus.value = flow.value.flowStatusType;
    organizeOutputData(JSON.parse(JSON.stringify(currentFlow.steps)));
    changeDrawerData();
    changeListItemOfBreadcrumb({
      labelKey: "Common.Edit",
      route: "",
      disabled: true,
      isTranslated: false,
      uniqueLabel: `${flow.value.name} / v.${flow.value.version}`,
    });
    if (flow.value.schedule) {
      nextRunTime.value = flow.value.schedule.nextFireTime;
    }
    resetStepLines();
    await fetchTimezone();
  }
}
function organizeOutputData(stepList) {
  outputList.value = getOutputListForAllStep(stepList);
}

function openDrawer(step, index, insideRouter) {
  if (!stepLoading.value) {
    if (
      drawerVisible.value &&
      selectedStep.value &&
      selectedStep.value.id === step.id
    ) {
      closeDrawer();
    } else {
      if (drawerVisible.value && editStepRef.value) {
        editStepRef.value.updateCurrentSavedData();
      }
      functionsVisible.value = false;
      infoVisible.value = false;
      userVariableVisible.value = false;
      configurationVisible.value = false;
      routerVisible.value = false;
      conditionVisible.value = false;
      delayVisible.value = false;
      selectedIndex.value = index;
      const stepList = useAddPositionToStep(steps.value);
      updateSelectedStep(stepList, step);
      isStepInRouter.value = !!insideRouter;
      drawerVisible.value = true;
      editStepKey.value++;

      nextTick(() => {
        setTimeout(() => {
          autoScrollStepElement(insideRouter);
        }, 100);
      });
    }
  }
}
async function getPaddingValue(padding: string) {
  return padding.includes("px") ? parseInt(padding.split("px")[0], 10) : 16;
}

async function resetAutoScrollPadding() {
  paddingTopForCentering.value = "1rem";
  paddingLeftForCentering.value = "1rem";
  paddingRightForCentering.value = "1rem";
  paddingBottomForCentering.value = "1rem";
}

async function applyAutoScrollPadding(
  scrollX,
  scrollY,
  visibleRect,
  leftContainerWrapper,
  selectedElementRect
) {
  const defaultValue = "1rem";
  const leftContainerWrapperWidth = leftContainerWrapper.scrollWidth;
  const leftContainerWrapperHeight = leftContainerWrapper.scrollHeight;

  if (scrollX < 0) {
    paddingLeftForCentering.value = `${Math.abs(scrollX)}px`;
  } else {
    paddingLeftForCentering.value = defaultValue;
  }
  if (scrollY < 0) {
    paddingTopForCentering.value = `${Math.abs(scrollY)}px`;
  } else {
    paddingTopForCentering.value = defaultValue;
  }
  if (scrollX + visibleRect.width > leftContainerWrapperWidth) {
    paddingRightForCentering.value = `${
      scrollX +
      visibleRect.width +
      selectedElementRect.width -
      leftContainerWrapperWidth
    }px`;
  } else {
    paddingRightForCentering.value = defaultValue;
  }
  if (scrollY + visibleRect.height > leftContainerWrapperHeight) {
    paddingBottomForCentering.value = `${
      scrollY +
      visibleRect.height +
      selectedElementRect.height -
      leftContainerWrapperHeight
    }px`;
  } else {
    paddingBottomForCentering.value = defaultValue;
  }
}

async function autoScrollStepElement(id: string) {
  const existingLeftPadding = await getPaddingValue(
    window.getComputedStyle(document.getElementById("left-step-container"))
      .paddingLeft
  );
  const existingTopPadding = await getPaddingValue(
    window.getComputedStyle(document.getElementById("left-step-container"))
      .paddingTop
  );
  const leftContainerWrapper = document.getElementById("left-container");
  const selectedElementRect = leftContainerWrapper
    .querySelector(`#${id}`)
    ?.getBoundingClientRect();
  const visibleRect = leftContainerWrapper?.getBoundingClientRect();
  const relativeX =
    leftContainerWrapper.scrollLeft +
    selectedElementRect.x -
    visibleRect.x -
    existingLeftPadding;
  const relativeY =
    leftContainerWrapper.scrollTop +
    selectedElementRect.y -
    visibleRect.y -
    existingTopPadding;
  const scrollX =
    relativeX - (visibleRect.width - selectedElementRect.width) / 2;
  const scrollY =
    relativeY - (visibleRect.height - selectedElementRect.height) / 2;
  applyAutoScrollPadding(
    scrollX,
    scrollY,
    visibleRect,
    leftContainerWrapper,
    selectedElementRect
  );
  await nextTick();
  leftContainerWrapper.scrollTo({
    left: scrollX,
    top: scrollY,
    behavior: "smooth",
  });
}

function openRouterSettings(step, index, listIndex) {
  if (
    routerVisible.value &&
    selectedStep.value &&
    selectedStep.value.id === step.id
  ) {
    closeRouterSettings();
  } else {
    infoVisible.value = false;
    userVariableVisible.value = false;
    configurationVisible.value = false;
    conditionVisible.value = false;
    drawerVisible.value = false;
    delayVisible.value = false;
    // eslint-disable-next-line no-unused-expressions
    editStepRef.value?.updateCurrentSavedData();
    selectedIndex.value = index;
    selectedStep.value = step;
    routerVisible.value = true;
    functionsVisible.value = false;
    routerListIndex.value = listIndex;

    nextTick(() => {
      setTimeout(() => {
        autoScrollStepElement(`router${listIndex}`);
      }, 500);
    });
  }
}

function closeRouterSettings() {
  if (dragScrollActive.value) return;
  selectedIndex.value = undefined;
  selectedStep.value = undefined;
  routerVisible.value = false;
  functionsVisible.value = false;
  routerListIndex.value = undefined;
  resetAutoScrollPadding();
}

function closeDrawer() {
  if (dragScrollActive.value) return;
  if (!stepLoading.value) {
    // eslint-disable-next-line no-unused-expressions
    editStepRef.value?.updateCurrentSavedData();
  }
  isStepInRouter.value = false;
  selectedIndex.value = undefined;
  selectedStep.value = undefined;
  drawerVisible.value = false;
  functionsVisible.value = false;
  expressionDrawer.value = false;
  resetAutoScrollPadding();
}

watch(
  () => backgroundColor.value,
  () => {
    updateSinglePreference("editFlowBackground", backgroundColor.value);
  }
);

function closeAllDrawers() {
  drawerVisible.value = false;
  conditionVisible.value = false;
  routerVisible.value = false;
  delayVisible.value = false;
  infoVisible.value = false;
  userVariableVisible.value = false;
  configurationVisible.value = false;
  functionsVisible.value = false;
  resetAutoScrollPadding();
}

function addStep() {
  const step = {
    id: `new-step-${uuidv4()}`,
    uniqueId: uniqueId(),
  };
  steps.value.push(step);
}

function insertAtIndex(index) {
  if (index === steps.value.length) {
    addStep();
  } else {
    const step = {
      id: uniqueId("new-inserted-step"),
    };
    steps.value.splice(index, 0, step);
  }
  if (drawerVisible.value) {
    selectedIndex.value = steps.value.findIndex(
      (step) => step.id === selectedStep.value.id
    );
  }
  updateStep(true);
}

function removeStep(index, step) {
  if (selectedStep.value.id === step.id) {
    closeDrawer();
  }
  onRemoveStep(steps.value, step);
  resetStepLines();
  updateStep(true);
}

function onRemoveStep(list, targetStep) {
  list.forEach((item, index) => {
    if (item.id === targetStep.id) {
      list.splice(index, 1);
    }
    if (item.type) {
      item.routes.forEach((route) => onRemoveStep(route.steps, targetStep));
    }
  });
}
function updateStep(isChanged) {
  isAnyChange.value = isChanged;
  EventBus.isAnyChange = isChanged;
}
function onFlowChange() {
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
}
const selectedOffset = ref<string | null>(null);
const selectedIdentifier = ref<string | null>(null);

function handleTimezoneChange(offset: string) {
  const timezoneValue = timezoneOffsets.find((tz) => tz.offset === offset);
  if (timezoneValue) {
    selectedOffset.value = offset;
    selectedIdentifier.value = timezoneValue.identifier;
    flow.value.timeZone = selectedIdentifier.value;
  }
}

async function fetchTimezone() {
  const identifier = flow.value.timeZone;
  const timezoneValue = timezoneOffsets.find(
    (tz) => tz.identifier === identifier
  );
  if (timezoneValue) {
    selectedOffset.value = timezoneValue.offset;
    selectedIdentifier.value = timezoneValue.identifier;
  }
}

function onStepChange(index, stepData) {
  if (stepData?.name && stepData?.name.length > charLimit.value) {
    const shortenedName = stepData.name.substring(0, 50);
    // eslint-disable-next-line max-len
    showAlert(
      TYPE.ERROR,
      t("Common.StepNameCharLimitWarning", {
        limit: charLimit.value,
        name: shortenedName,
      })
    );
    isStepNameExceedingCharLimit.value = true;
    return;
  }
  isStepNameExceedingCharLimit.value = false;
  // Position data and output lists don't change during typing —
  // the deep watcher on steps.value handles output recomputation.
  updateStepData(steps.value, stepData);
}

function updateStepData(stepList, stepData) {
  stepList.forEach((step, index) => {
    if (!step.type) {
      if (step.id === stepData.id) {
        stepList[index] = stepData;
      }
    } else {
      step.routes.forEach((items) => {
        updateStepData(items.steps, stepData);
      });
    }
  });
}

function onRouterChange(index, routerStep) {
  updateRouteStep(steps.value, routerStep);
  steps.value = useAddPositionToStep(steps.value);
  resetStepLines();
}

function updateRouteStep(stepList, routeStep) {
  stepList.forEach((step, index) => {
    if (step.type) {
      if (
        step?.uniqueId === routeStep?.uniqueId &&
        step?.ix === routeStep?.ix &&
        step?.iy === routeStep?.iy
      ) {
        stepList[index] = routeStep;
      } else {
        step.routes.forEach((list) => {
          updateRouteStep(list.steps, routeStep);
        });
      }
    }
  });
}

function updateStepsFilter(stepList, filter, filterStep) {
  stepList.forEach((step) => {
    if (!step.type) {
      if (step?.uniqueId === filterStep?.uniqueId) {
        step.filter = filter;
      }
    } else {
      step.routes.forEach((items) => {
        updateStepsFilter(items.steps, filter, filterStep);
      });
    }
  });
}

function updateSelectedRouterStep(stepList, currentStep) {
  stepList.forEach((step) => {
    if (step.type) {
      if (step.id === currentStep.id) {
        selectedStep.value = step;
      } else {
        step.routes.forEach((items) => {
          updateSelectedRouterStep(items.steps, currentStep);
        });
      }
    }
  });
}

function updateSelectedStep(stepList, currentStep) {
  stepList.forEach((step) => {
    if (!step.type) {
      if (step.id === currentStep.id) {
        selectedStep.value = { ...step };
      }
    } else {
      step.routes.forEach((items) => {
        updateSelectedStep(items.steps, currentStep);
      });
    }
  });
}

function updateStepsDelay(stepList, delay, delayStep) {
  stepList.forEach((step) => {
    if (!step.type) {
      if (step.id === delayStep.id) {
        step.delay = delay;
      }
    } else {
      step.routes.forEach((items) => {
        updateStepsDelay(items.steps, delay, delayStep);
      });
    }
  });
}

let pendingSyncRafId: number | null = null;

function updateStepList({
  list,
  extra,
  onlyLineUpdate,
}: {
  list: any;
  extra: ChangedStep | AddedStep | RemovedStep;
  onlyLineUpdate: boolean;
}) {
  closeAllDrawers();
  const stepsThatPositionWasUpdated = useAddPositionToStep(
    preserveUdvChangeMaps(list, steps.value)
  );

  if (!onlyLineUpdate) {
    steps.value = cloneDeep(stepsThatPositionWasUpdated);
  }

  if (extra) {
    const flowSnapshot = {
      ...flow.value,
      steps: stepsThatPositionWasUpdated,
    };
    const extraSnapshot = { ...extra };
    if (pendingSyncRafId) cancelAnimationFrame(pendingSyncRafId);
    pendingSyncRafId = requestAnimationFrame(() => {
      pendingSyncRafId = null;
      const synced = useSyncInputData({
        flow: flowSnapshot,
        ...extraSnapshot,
      });
      steps.value = cloneDeep(synced);
    });
  }

  if (drawerVisible.value && selectedStep?.value?.uniqueId && extra) {
    const stepData = findStepOrRouteByUniqueId(
      {
        ...flow.value,
        steps: stepsThatPositionWasUpdated,
      } as FlowType,
      selectedStep?.value?.uniqueId
    );
    selectedStep.value = stepData;
    editStepKey.value++;
  }
  if (!dragged || onlyLineUpdate) {
    resetStepLines();
  }

  dragged = false;
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
}
function outputListFilter() {
  if (selectedStep.value.type === "ROUTER") {
    updateSelectedRouterStep(steps.value, selectedStep.value);
  }
  return outputList.value.filter(
    (item) =>
      selectedStep.value.availableOutput.some(
        (x) => x.uniqueId === item.uniqueId
      ) ||
      (selectedStep.value.uniqueId === item.uniqueId && !item.type)
  );
}
function metaoutputListFilter() {
  if (selectedStep.value.type === "ROUTER") {
    updateSelectedRouterStep(steps.value, selectedStep.value);
  }
  return metaoutputList.value.filter(
    (item) =>
      selectedStep.value.availableMetaoutput.some(
        (x) => x.uniqueId === item.uniqueId
      ) ||
      (selectedStep.value.uniqueId === item.uniqueId && !item.type)
  );
}
async function updateEditFlow(data, doNotUpdateFlow = false) {
  connections.value = await getConnections();
  connectors.value = await getOrganizationsConnectorList();
  // If editing flow instead of creating
  if (flowId.value) {
    await getSelectedFlow({ doNotUpdateFlow });
  }
  if (data) {
    componentKey.value++;
  }
}

// OT-5040: submitFlow only sets responseLoading after its awaits and the step-tree walk, so
// repeated Save clicks in that window each sent a PUT /flows with the same version and the
// backend saved every one (steps duplicated per click). Hand concurrent callers the in-flight
// save instead of starting another; awaiting callers still resume once that save settles.
let inFlightSubmit: Promise<void> | null = null;
function onFlowSubmit() {
  if (!inFlightSubmit) {
    isSubmitting.value = true;
    inFlightSubmit = submitFlow().finally(() => {
      inFlightSubmit = null;
      isSubmitting.value = false;
    });
  }
  return inFlightSubmit;
}

async function submitFlow() {
  flushFlowInputs();
  await nextTick();

  const invalidVariables = userDefinedVariables.value.filter(
    (item) => !item.value.itemKey && item.value.itemValue
  );

  if (executionList?.value?.length > 0 && !selectedExecution.value) {
    showAlert(TYPE.WARNING, t("Common.ExecutionRequired"));
    return;
  }

  if (treeSource.value === "exec") {
    await submitExecSwitch();
  }

  if (treeSource.value === "config") {
    await submitConfigChanges();
  }
  if (invalidVariables.length > 0) {
    showAlert(TYPE.WARNING, t("Common.EmptyItemKeyWarning"));
    return;
  }

  const invalidErrors = udvErrors.value.filter((err) => !err.flag);

  if (invalidErrors.length > 0) {
    const stepMessages = invalidErrors
      .map((err) =>
        t("Common.StepCheckUserDefinedVariables", {
          step: getUdvErrorStepNumber(err),
        })
      )
      .join("\n");
    showAlert(TYPE.ERROR, stepMessages);
    return;
  }
  if (
    flow?.value?.name?.length > currentCharLimit.value ||
    flow?.value?.description?.length > currentCharLimit.value
  ) {
    showAlert(
      TYPE.ERROR,
      t("Common.CharacterLimitWarning", { limit: currentCharLimit.value })
    );
    return;
  }

  if (drawerVisible.value && editStepRef.value) {
    // eslint-disable-next-line no-unused-expressions
    editStepRef.value?.updateCurrentSavedData();
    if (editStepRef.value) {
      editStepRef.value.resetConnectionAndActionChanges();
    }
  }

  if (hasPermission("FLOWS.FLOW.SAVE") && flow.value.name) {
    flow.value.steps = useAddPositionToStep(filterSteps(steps.value));
    responseLoading.value = true;
    const isConditionValid = isAnyRouteHasNotFilterProp(flow.value.steps);
    const isStepValid = isAnyStepHasNotConnectorProp(flow.value.steps);

    if (!isConditionValid) {
      responseLoading.value = false;
      showAlert(TYPE.ERROR, t("Flow.ConditionIsRequired"));
      return;
    }

    const invalidFilters = findInvalidStepFilterIndex(steps.value);
    if (invalidFilters.length > 0) {
      responseLoading.value = false;
      showAlert(
        TYPE.ERROR,
        `${t("Flow.FilterIsRequired")} ${invalidFilters.join(", ")}.`
      );
      return;
    }
    if (isReportModeSelected(flow.value)) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.SendReport"));
      return;
    }
    if (!isStepValid) {
      responseLoading.value = false;
      showAlert(TYPE.ERROR, t("Flow.ConnectorIsRequired"));
      return;
    }

    if (isDuplicateKeys()) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.KeyIsAlreadyExist"));
      return;
    }

    if (isSpecialCharEntered.value) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.KeyIncluedSpecialChar"));
      return;
    }

    // Normalization is debounced + async, so the parent's `flow.schedule` lags the form.
    // Settle it before saving, otherwise a quick save persists the PREVIOUS schedule.
    if (cronEditorRef.value) {
      const scheduleValid = await cronEditorRef.value.flushSchedule();
      if (!scheduleValid) {
        responseLoading.value = false;
        showAlert(
          TYPE.ERROR,
          cronEditorRef.value.scheduleError || t("Flow.ScheduleWarning")
        );
        return;
      }
    }

    if (isScheduledFlow(flow.value) && !isScheduled(flow.value)) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.ScheduleWarning"));
      return;
    }
    if (
      flow?.value?.scheduleType === "SCHEDULED" &&
      flow?.value?.schedule?.settings?.selectedScheduleType === "ADVANCED"
    ) {
      const valid = await validateCronExpression(
        flow?.value?.schedule?.cronExpr
      );
      if (!valid) {
        responseLoading.value = false;
        showAlert(TYPE.ERROR, t("Schedule.InvalidCronSyntax"));
        return;
      }
    }
    flow.value.userDefinedVariables = formatUserDefinedVariables();

    try {
      if (currentRoute.value.params.id) {
        if (isStepNameExceedingCharLimit.value) {
          responseLoading.value = false;
          return;
        }
        if (!flow.value.timeZone) {
          // get user's local time zone
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          flow.value.timeZone = userTimeZone;
        }
        const response = await editFlow(flow.value);
        if (response) {
          showAlert(TYPE.SUCCESS, t("Flow.FlowUpdated"));
          isVersionChanged.value = true;
          await router.push(`/flows/edit/${response.id}/${response.version}`);
          await getSelectedFlow({ newFlow: response });
          await getConfigurationVariables();
          if (aiSkillGeneratorEnabled.value) resumeSkillStatus();
        }
      } else {
        if (!flow.value.timeZone) {
          // get user's local time zone
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          flow.value.timeZone = userTimeZone;
        }
        const response = await addFlow(flow.value);
        if (response) {
          showAlert(TYPE.SUCCESS, t("Flow.FlowCreated"));
          isVersionChanged.value = true;
          await router.push(`/flows/edit/${response.id}/${response.version}`);
          await getSelectedFlow({ newFlow: response });
          await getConfigurationVariables();
          checkReportStatus();
        }
      }
      responseLoading.value = false;
      isAnyChange.value = false;
      EventBus.isAnyChange = false;
    } catch (e) {
      responseLoading.value = false;
      showAlert(TYPE.ERROR, e.message ?? t("UnknownError"));
    }
  } else if (flow.value.name === "") {
    showAlert(TYPE.WARNING, "Please fill name");
    if (!infoVisible.value) {
      showInfo();
    }
  }
}

async function flowRevert() {
  if (flowId.value) {
    const isConfirmed = await showConfirm(
      "warning",
      "Revert Flow",
      "Are you sure revert to this version?"
    );
    if (isConfirmed) {
      responseLoading.value = true;
      const response = await revertFlow(flowId.value, flow.value.version);
      if (response) {
        await switchFlow(response.id, response.version);
        showAlert(TYPE.SUCCESS, t("Flow.RevertSuccess"));
      }
      responseLoading.value = false;
    }
  }
}

function changeDrawerData() {
  if (drawerVisible.value && selectedIndex.value !== undefined) {
    const stepList = useAddPositionToStep(steps.value);
    updateSelectedStep(stepList, selectedStep.value);
    drawerVisible.value = false;
    if (selectedStep.value) {
      drawerVisible.value = true;
    }
  }
}

async function updateFlow() {
  if (
    areStepsValid.value &&
    updatedFlow.value.name &&
    hasPermission("FLOWS.FLOW.SAVE")
  ) {
    updatedFlow.value.steps = filterSteps(steps.value);
    try {
      const response = await editFlow(updatedFlow.value);
      if (response) {
        showAlert(TYPE.SUCCESS, t("Flow.FlowUpdated"));
        isAnyChange.value = false;
        EventBus.isAnyChange = false;
      }
    } catch (e) {
      showAlert(TYPE.ERROR, e.message);
    }
  }
}

function listChanged(type) {
  if (type) {
    organizeOutputData(steps.value);
  }

  // isStepInRouter.value = false;
  // selectedIndex.value = undefined;
  // selectedStep.value = undefined;
  // drawerVisible.value = false;
  // functionsVisible.value = false;
  // console.log("listChanged", "listChanged");

  if (!drawerVisible.value) {
    dragIndex.value = type.moved.element.ix;
  }
}

function filterSteps(list) {
  const stepList = JSON.parse(JSON.stringify(list));
  stepList.forEach((step, index) => {
    if (typeof step.id === "string" && !checkIfValidUUID(step.id)) {
      step.id = undefined;
    }
    if (step.type) {
      step.name = "router";
      step.routes.forEach((route) => {
        route.steps = filterSteps(route.steps);
      });
    }

    stepList.splice(index, 1, step);
  });
  return stripUdvValueOnlyRows(stepList);
}

function checkIfValidUUID(str) {
  const regexExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return regexExp.test(str);
}

function checkStepsValid() {
  let valid = true;
  steps.value.forEach((step) => {
    if (!step.type) {
      // Connection-optional steps have no connection but carry a connectorSpecId.
      if ((!step.connection && !step.connectorSpecId) || !step.actions) {
        valid = false;
      }
    }
  });
  return valid;
}

const areStepsValid = computed(() => checkStepsValid());
const systemVariables = ref([]);

function updateSimulating(simulating) {
  stepSimulating.value = simulating;
}

async function handleSimulationUpdateOutput() {
  await updateEditFlow(false, true);
  simulationDataRefreshKey.value++;
}

function updatePopUpOpen(isOpen) {
  popUpOpen.value = isOpen;
}
function runFlow(name) {
  if (flow.value.active && !isAnyChange.value) {
    stepSimulating.value = true;
    if (hasPermission("FLOWS.LIST.RUN") && flowId.value) {
      flowName.value = name;
      outputLogs.value = [];
      if (flowRunning.value && client) {
        runFlowDialog.value = true;
      } else {
        startFlow(flowId.value, version.value)
          .then((response) => {
            runFlowDialog.value = true;
            readFlowProcess();
            activityId.value = response;
          })
          .catch(() => {
            showAlert(TYPE.ERROR, "An error occurred while starting the flow.");
          });
      }
    }
  } else if (!flow.value.active) {
    showAlert(TYPE.ERROR, t("Flow.InactiveFlow"));
  } else if (isAnyChange.value) {
    showAlert(TYPE.WARNING, t("Flow.UnsavedChanges"));
  }
}

async function simulateSelectedStep(
  bypassConditions = false,
  opts: { silent?: boolean; reason?: string } = {}
) {
  if (!selectedStep.value) return;

  if (isAnyChange.value) {
    await onFlowSubmit();
    if (isAnyChange.value) return;
    await nextTick();
  }

  if (!editStepRef.value) return;
  await editStepRef.value.simulate(bypassConditions, opts);
}

async function onSaveAfterSpec({ autoValidate }: { autoValidate: boolean }) {
  try {
    await onFlowSubmit();
  } catch {
    showAlert(TYPE.WARNING, t("Flow.JoltSaveFailedAfterGeneration"));
    return;
  }

  if (isAnyChange.value) {
    showAlert(TYPE.WARNING, t("Flow.JoltSaveFailedAfterGeneration"));
    return;
  }

  showAlert(TYPE.SUCCESS, t("Flow.JoltSavedAfterGeneration"));

  if (autoValidate) {
    try {
      await simulateSelectedStep(false, {
        silent: true,
        reason: "validate-after-spec",
      });
    } catch (err) {
      // Save already succeeded — a validation error must not be reported as a
      // save failure. EditStep surfaces validation failures via its own toast.
      console.error("Post-generation validation failed:", err);
    }
  }
}

function readFlowProcess() {
  if (client) {
    outputLogs.value = [];
    client.disconnect();
    client = undefined;
  }
  if (flow.value.scheduleType !== "SCHEDULED") {
    stepSimulating.value = true;
  }
  const { checkIsRunActivityFromSocket } = useActivity();
  connectWebsocket().then((stompClient) => {
    stompClient.debug = (f) => f;
    client = stompClient;
    stompClient.connect({}, async () => {
      stompClient.subscribe(`/flow/${flowId.value}/process`, async (val) => {
        if (flow.value.scheduleType === "SCHEDULED") {
          runFlowDialog.value = true;
          stepSimulating.value = true;
        }
        outputLogs.value.push(val.body);
      });
      stepSimulating.value = await checkIsRunActivityFromSocket(
        stompClient,
        activityId.value,
        undefined,
        updateActivityStatus
      );
    });
  });
  processLogs.value = outputLogs.value;
}

function updateActivityStatus(activityStatus) {
  flow.value.currentActivityStatus = activityStatus;
}

async function downloadLogsAsText(flowVal) {
  if (!activityId.value) {
    showAlert(TYPE.WARNING, t("Flow.ProcessLogDownloadError"));
    return;
  }
  const response = await getFlowLogZipById(activityId.value);
  const blob = new Blob([response], { type: "application/zip" });
  const link = document.createElement("a");
  link.setAttribute("download", `${flowVal.name}-flow-logs.zip`);
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

function expressionDrawerStatus(value) {
  expressionDrawer.value = value;
}

function getFlowExecutionType(): string | null {
  const typeFromFlow =
    flow.value?.execution?.type ?? flow.value?.execution?.executionType;
  if (typeFromFlow) return String(typeFromFlow).toUpperCase();

  const node = findInTree(tree.value, (n) => n.label === "flow.execution");
  return node?.inputValue ? String(node.inputValue).toUpperCase() : null;
}

function findInTree<T extends { children?: T[] }>(
  nodes: T[] | null | undefined,
  predicate: (n: T) => boolean
): T | null {
  if (!Array.isArray(nodes) || nodes.length === 0) return null;
  let result: T | null = null;
  nodes.some((n) => {
    if (predicate(n)) {
      result = n;
      return true; // stop .some()
    }
    const found = findInTree(n.children, predicate);
    if (found) {
      result = found;
      return true; // stop .some()
    }
    return false;
  });
  return result;
}

function stopRunningFlow() {
  if (hasPermission("FLOWS.LIST.STOP")) {
    if (client) {
      client.disconnect();
      client = undefined;
    }
    if (getFlowExecutionType() === "NATIVE") {
      showAlert(TYPE.WARNING, t("Flow.StoppingNativeFlowError"));
      stepSimulating.value = false;
      updateEditFlow(false);
      closeFlowDialog();
    } else {
      stopFlow(activityId.value)
        .then(() => {
          flowStatus.value = "STOPPED";
          flow.value.flowStatusType = "STOPPED";
          stepSimulating.value = false;
          updateEditFlow(false);
        })
        .catch(() => {
          showAlert(TYPE.ERROR, "An error occurred while stopping the flow.");
        })
        .finally(() => {
          flowStatus.value = "STOPPED";
          closeFlowDialog();
        });
    }
  }
}

function closeFlowDialog() {
  runFlowDialog.value = false;
}

async function switchFlow(id, versionNumber) {
  isVersionChanged.value = true;

  const flowData = await getFlow(id, String(versionNumber));
  const isNewUi = !!flowData?.newUi;

  const targetRouteName = isNewUi ? "editFlowsRouteNew" : "editFlows";

  const query: Record<string, any> = { ...currentRoute.value.query };

  if (isNewUi) {
    query.migrated = "true";
  } else {
    delete query.migrated;
  }

  await router.push({
    name: targetRouteName,
    params: { id, version: versionNumber },
    query,
  });

  if (!isNewUi) {
    await getSelectedFlow();
    setActiveOne();
  }
}

function updateResponseLoading(loading) {
  responseLoading.value = loading;
}

function updateDragging(args) {
  // allows; do not recreate step lines but only update step list
  dragged = true;
  // stops bubbling of the grab and scroll canvas and grab and drag step
  customStopPropagation.value = args.stopPropagation;
}

let lineRecreationScheduled = false;
function resetStepLines() {
  if (lineRecreationScheduled) return;
  lineRecreationScheduled = true;
  requestAnimationFrame(() => {
    removeLeaderLines(flowLineWrapper.value, () => {
      requestAnimationFrame(() => {
        addStepLines();
      });
    });
  });
}

function addStepLines() {
  try {
    const { createOrUpdateLines } = useLoopLines(
      steps.value,
      loopLineWrapper.value
    );
    createOrUpdateLines();
    createStepLinesChunked(steps.value, "", flowLineWrapper.value, true, () => {
      setTimeout(() => isLineCreated(), 10);
    });
  } finally {
    lineRecreationScheduled = false;
  }
}
function isLineCreated() {
  if (lineRecreationScheduled) return;
  const { lineCount } = useLoopLines(steps.value, loopLineWrapper.value);
  const stepCount = document.getElementsByClassName("stepBoxCount").length;

  const allLineElementsCount =
    flowLineWrapper.value?.childElementCount +
    loopLineWrapper.value?.childElementCount;
  if (allLineElementsCount === 0) {
    addStepLines();
  } else if (allLineElementsCount !== stepCount + lineCount - 1) {
    resetStepLines();
  } else if (allLineElementsCount === stepCount + lineCount - 1) {
    // console.log("Lines are created!");
  } else {
    setTimeout(() => isLineCreated(), 50);
  }
}

function mouseDown(event) {
  // stabilize mouse wheel(middle) click
  if (event.button === 1) {
    return;
  }
  isMouseDown.value = true;
  isStepBoxClicked.value = !!(
    event.target instanceof Element &&
    event.target.closest(".step-section, .router-section")
  );
  startX = event.pageX - scrollContainer.value.offsetLeft;
  startY = event.pageY - scrollContainer.value.offsetTop;
  scrollLeft = scrollContainer.value.scrollLeft;
  scrollTop = scrollContainer.value.scrollTop;
}

function dragScroll(event) {
  if (!isMouseDown.value || customStopPropagation.value) return;
  dragScrollActive.value = true;
  const x = event.pageX - scrollContainer.value.offsetLeft;
  const y = event.pageY - scrollContainer.value.offsetTop;
  const walkX = x - startX;
  const walkY = y - startY;
  scrollContainer.value.scrollLeft = scrollLeft - walkX;
  scrollContainer.value.scrollTop = scrollTop - walkY;
}

function mouseUp(isAvailable = false) {
  if (!dragScrollActive.value && isAvailable) {
    if (!isStepBoxClicked.value) {
      onClickInsideElement();
    }
  }
  isMouseDown.value = false;
  dragScrollActive.value = false;
}

function onClickInsideElement() {
  if (dragScrollActive.value) return;
  if (drawerVisible.value) {
    closeDrawer();
  } else if (routerVisible.value) {
    closeRouterSettings();
  } else if (conditionVisible.value) {
    showCondition();
  } else if (delayVisible.value) {
    openDelay();
  }
}

let resizeStartX = 0;
let resizeStartWidth = 0;

function getActiveResizeBinding(): {
  widthRef: typeof editStepWidthPx;
  el: HTMLElement | null;
  min: number;
  max: number;
  prefKey: string;
} | null {
  if (drawerVisible.value && !conditionVisible.value && !infoVisible.value) {
    return {
      widthRef: editStepWidthPx,
      el: editStepBoxRef.value,
      min: EDIT_STEP_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(EDIT_STEP_BASE_MIN_WIDTH),
      prefKey: "editStepBoxWidthPx",
    };
  }
  if (infoVisible.value && !drawerVisible.value) {
    return {
      widthRef: editStepWidthPx,
      el: infoBoxRef.value,
      min: EDIT_STEP_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(EDIT_STEP_BASE_MIN_WIDTH),
      prefKey: "editStepBoxWidthPx",
    };
  }
  if (conditionVisible.value) {
    return {
      widthRef: conditionWidthPx,
      el: conditionBoxRef.value,
      min: CONDITION_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(CONDITION_BASE_MIN_WIDTH),
      prefKey: "conditionBoxWidthPx",
    };
  }
  if (routerVisible.value) {
    return {
      widthRef: routerWidthPx,
      el: routerBoxRef.value,
      min: ROUTER_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(ROUTER_BASE_MIN_WIDTH),
      prefKey: "routerBoxWidthPx",
    };
  }
  if (userVariableVisible.value) {
    return {
      widthRef: editStepWidthPx,
      el: userVarsBoxRef.value,
      min: EDIT_STEP_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(EDIT_STEP_BASE_MIN_WIDTH),
      prefKey: "editStepBoxWidthPx",
    };
  }
  if (wizardDrawerVisible.value) {
    return {
      widthRef: wizardWidthPx,
      el: wizardBoxRef.value,
      min: WIZARD_BASE_MIN_WIDTH,
      max: getWizardBaseMaxWidth(),
      prefKey: "wizardBoxWidthPx",
    };
  }
  return null;
}

const capture = { el: null as HTMLElement | null, id: 0 as number };
let resizeWidthRef: typeof editStepWidthPx | null = null;
let resizePrefKey = "editStepBoxWidthPx";

function startResize(e: PointerEvent) {
  const active = getActiveResizeBinding();
  if (!active?.el) return;

  e.preventDefault();

  // use currentTarget (the handle), not target (might be child)
  capture.el = e.currentTarget as HTMLElement | null;
  capture.id = e.pointerId;
  const handle = e.currentTarget as HTMLElement | null;
  if (handle && typeof handle.setPointerCapture === "function") {
    handle.setPointerCapture(e.pointerId);
  }

  isResizing.value = true;
  resizeStartX = e.clientX;
  resizeWidthRef = active.widthRef;
  resizePrefKey = active.prefKey;

  const rect = active.el.getBoundingClientRect();
  let activeReservePx = functionDrawerReservePx.value;
  if (active.prefKey === "wizardBoxWidthPx") {
    activeReservePx = wizardHistoryVisible.value
      ? WIZARD_HISTORY_DRAWER_WIDTH
      : 0;
  }
  resizeStartWidth = clamp(
    rect.width - activeReservePx,
    active.min,
    active.max
  );
  active.widthRef.value = Math.round(resizeStartWidth);

  document.documentElement.style.cursor = "ew-resize";
  document.body.style.userSelect = "none";

  window.addEventListener("pointermove", onResizeMove);
  window.addEventListener("pointerup", onResizeEnd, { once: true });
  window.addEventListener("pointercancel", onResizeEnd, { once: true });
  window.addEventListener("blur", onResizeEnd, { once: true });
}

function onResizeMove(e: PointerEvent) {
  if (!isResizing.value) return;
  const active = getActiveResizeBinding();
  if (!active) return;

  const dx = e.clientX - resizeStartX;
  const nextBase = clamp(resizeStartWidth + -dx, active.min, active.max);
  active.widthRef.value = Math.round(nextBase);
}

function onResizeEnd() {
  if (capture.el && typeof capture.el.releasePointerCapture === "function") {
    capture.el.releasePointerCapture(capture.id);
  }
  capture.el = null;
  capture.id = 0;

  isResizing.value = false;
  document.documentElement.style.cursor = "";
  document.body.style.userSelect = "";
  window.removeEventListener("pointermove", onResizeMove);
  if (resizeWidthRef) {
    saveWidthPref(resizePrefKey, resizeWidthRef.value);
  }
  resizeWidthRef = null;
  resizePrefKey = "editStepBoxWidthPx";
}

function clamp(v: number, min: number, max: number) {
  return Math.min(Math.max(v, min), max);
}

function getNumberPref(key: string, fallback: number): number {
  const raw = getPreferenceValue(key);
  const n = typeof raw === "string" ? parseInt(raw, 10) : Number(raw);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

function saveWidthPref(key: string, px: number) {
  updateSinglePreference(key, String(Math.round(px)));
}

function handleEmails(value) {
  const emails = value.split(";").map((email) => email.trim());
  emails.map((email) => validateEmail(email));
}

function validateEmail(value) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    invalidEmail.value = "";
    return true;
  }
  invalidEmail.value = t("Auth.EmailVal");
  return false;
}

function isReportModeSelected(flowToBeUpdated) {
  return (
    flowToBeUpdated.sendFlowReport &&
    !flowToBeUpdated.onError &&
    !flowToBeUpdated.onSuccess
  );
}

function isScheduledFlow(flowToBeUpdated) {
  if (flowToBeUpdated.scheduleType === "SCHEDULED") {
    return true;
  }
  return false;
}

function isScheduled(flowToBeUpdated) {
  const { schedule } = flowToBeUpdated;
  const isAdvanced = schedule?.settings?.selectedScheduleType === "ADVANCED";
  return (
    (isAdvanced || schedule?.scheduleTime !== null) &&
    schedule?.cronExpr !== "UNDEFINED_CRON" &&
    schedule?.cronExpr !== ""
  );
}

const observer = ref();
onMounted(() => {
  observer.value = new MutationObserver(() => {
    const leaderLine = document.querySelector(".leader-line");
    if (leaderLine) {
      leaderLine.setAttribute("class", "leader-line leader-shadow");
    }
  });
  observer.value.observe(document.body, { subtree: true, childList: true });
});
onUnmounted(() => {
  observer.value.disconnect();
});

async function publishFlow() {
  if (hasPermission("FLOWS.FLOW.SAVE")) {
    if (flow.value.flowStatusType === "DRAFT") {
      flow.value.flowStatusType = "PUBLISHED";
      const response = await editFlow(flow.value);
      if (response) {
        showAlert(TYPE.SUCCESS, t("Flow.FlowPublished"));
        isVersionChanged.value = true;
        await router.push(`/flows/edit/${response.id}/${response.version}`);
        await getSelectedFlow({ newFlow: response });
        if (aiSkillGeneratorEnabled.value) resumeSkillStatus();
      }
    }
  }
}

const clonedStep = ref();
function cloneStep(step) {
  clonedStep.value = step;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_inside_click = _resolveDirective("inside-click")!

  return (pageOpen.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: componentKey.value,
        id: "edit-flow",
        class: "full-size",
        style: _normalizeStyle({ backgroundColor: backgroundColor.value }),
        onClick: closeContextMenu
      }, [
        _createElementVNode("div", _hoisted_1, [
          (activeTab.value === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "edit-flow-content",
                ref_key: "editFlowContent",
                ref: editFlowContent,
                class: _normalizeClass(["d-flex width-100 height-100", { 'wizard-review-active': wizardReviewActive.value }])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _withDirectives((_openBlock(), _createElementBlock("div", {
                    id: "left-container",
                    ref_key: "scrollContainer",
                    ref: scrollContainer,
                    class: "p-3 d-flex width-100 height-100 cursor-grab select-none",
                    style: {"position":"relative","isolation":"isolate"},
                    onMousemove: dragScroll,
                    onMousedown: mouseDown,
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (isMouseDown.value = false))
                  }, [
                    _createElementVNode("div", {
                      id: "left-step-container",
                      style: _normalizeStyle({
                paddingTop: paddingTopForCentering.value,
                paddingLeft: paddingLeftForCentering.value,
              })
                    }, [
                      _createElementVNode("div", {
                        ref_key: "flowLineWrapper",
                        ref: flowLineWrapper,
                        id: "flow-line-wrapper",
                        style: {"width":"0","height":"0","position":"relative"}
                      }, null, 512),
                      _createElementVNode("div", {
                        ref_key: "loopLineWrapper",
                        ref: loopLineWrapper,
                        id: "loop-line-wrapper",
                        style: {"width":"0","height":"0","position":"relative"}
                      }, null, 512),
                      (!pageLoading.value && !wizardReviewActive.value)
                        ? (_openBlock(), _createBlock(_unref(StepContainer), {
                            key: 0,
                            steps: steps.value,
                            "drawer-visible": drawerVisible.value,
                            top: 0,
                            left: 0,
                            "selected-index": selectedIndex.value,
                            "pop-up-open": popUpOpen.value,
                            "step-loading": stepLoading.value,
                            "list-index": '',
                            "selected-step": selectedStep.value,
                            "cloned-step": clonedStep.value,
                            paddingBottomForCentering: paddingBottomForCentering.value,
                            onUpdateDragging: updateDragging,
                            onUpdate: updateStepList,
                            onOpenDrawer: openDrawer,
                            onContextMenu: contextMenuEvt,
                            onOpenDelay: openDelay,
                            onOpenFilter: showCondition,
                            onRemoveStep: removeStep,
                            onShowCondition: showCondition,
                            onOpenRouter: openRouterSettings,
                            onListChanged: listChanged,
                            onInsertAtIndex: insertAtIndex,
                            onCloseDrawer: closeDrawer,
                            onCloneStep: cloneStep,
                            onOpenOutput: openOutput
                          }, null, 8, ["steps", "drawer-visible", "selected-index", "pop-up-open", "step-loading", "selected-step", "cloned-step", "paddingBottomForCentering"]))
                        : _createCommentVNode("", true)
                    ], 4),
                    (wizardReviewActive.value)
                      ? (_openBlock(), _createBlock(FlowPreviewOverlay, {
                          key: 0,
                          "flow-spec": wizardPreviewFlowSpec.value,
                          "approval-intent": flowId.value ? 'update' : 'create',
                          submitting: wizardPreviewSubmitting.value,
                          style: {"position":"absolute","inset":"0","z-index":"20"},
                          onApprove: handleWizardPreviewApprove,
                          onReject: handleWizardPreviewReject,
                          onFeedback: handleWizardPreviewFeedback
                        }, null, 8, ["flow-spec", "approval-intent", "submitting"]))
                      : _createCommentVNode("", true)
                  ], 32)), [
                    [_vShow, combinedConnections.value.length !== 0],
                    [_directive_inside_click, {
              handle: (isAvailable) => {
                mouseUp(isAvailable);
              },
              disabledScopeElements: [
                '.step-section',
                '.router-section',
                '.resize-item',
              ],
              eventListenerType: 'mouseup',
              eventStartScopeElements: ['#left-container'],
              eventStartListenerType: 'mousedown',
              injectable: true,
            }]
                  ]),
                  _hoisted_3,
                  (combinedConnections.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (!pageLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createTextVNode(_toDisplayString(_unref(hasPermission)("CONNECTIONS.LIST.CREATE")
                  ? _unref(t)("Flow.ConnectionWarning")
                  : _unref(t)("Flow.ConnectionWarning2")) + " ", 1),
                              (_unref(hasPermission)('CONNECTIONS.LIST.CREATE'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-oneTeg margin-top-10",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/connections/create')))
                                  }, _toDisplayString(_unref(t)("Common.Create")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (drawerVisible.value && !conditionVisible.value && !infoVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "edit-step-box",
                      ref_key: "editStepBoxRef",
                      ref: editStepBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", [
            {
              'drawer-visible': drawerVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ]]),
                      style: _normalizeStyle({
            width: currentEditStepWidthPx.value + 'px',
            minWidth: minEditStepWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      (_openBlock(), _createBlock(_unref(EditStep), {
                        class: _normalizeClass(`oneteg-drawer-${getSizeByValue(editStepSize.value)}`),
                        size: currentEditStepWidthPx.value,
                        connections: combinedConnections.value,
                        step: selectedStep.value,
                        key: editStepKey.value,
                        "step-idx": selectedIndex.value,
                        "step-simulating": stepSimulating.value,
                        popUpOpen: popUpOpen.value,
                        outputList: outputList.value,
                        metaoutputList: metaoutputList.value,
                        userDefinedVariables: userDefinedVariables.value,
                        "system-variables": systemVariables.value,
                        expressions: expressions.value,
                        visible: drawerVisible.value,
                        "is-step-in-router": isStepInRouter.value,
                        flow: flow.value,
                        "is-step-changed": isAnyChange.value,
                        "id-suffix": 0,
                        onExpressionDrawer: expressionDrawerStatus,
                        onStepChange: updateStep,
                        onAddStep: _cache[2] || (_cache[2] = ($event: any) => (insertAtIndex($event))),
                        onUpdateSimulate: _cache[3] || (_cache[3] = ($event: any) => (updateSimulating($event))),
                        onUpdatePopUpOpen: _cache[4] || (_cache[4] = ($event: any) => (updatePopUpOpen($event))),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (onStepChange(selectedIndex.value, $event))),
                        onClose: _cache[6] || (_cache[6] = ($event: any) => (removeStep(selectedIndex.value, selectedStep.value))),
                        onUpdate: updateFlow,
                        onCloseDrawer: closeDrawer,
                        onSetLoading: setLoading,
                        onChangeFunctionVisible: changeFunctionsVisible,
                        onUpdateOutput: handleSimulationUpdateOutput,
                        onUpdateCurrentActivityStatus: updateActivityStatus,
                        onSimulateForSpec: _cache[7] || (_cache[7] = (opts) => simulateSelectedStep(false, opts)),
                        onSaveAfterSpec: onSaveAfterSpec,
                        ref_key: "editStepRef",
                        ref: editStepRef,
                        onUdvError: handleUdvError,
                        "simulation-data-refresh-key": simulationDataRefreshKey.value
                      }, null, 8, ["class", "size", "connections", "step", "step-idx", "step-simulating", "popUpOpen", "outputList", "metaoutputList", "userDefinedVariables", "system-variables", "expressions", "visible", "is-step-in-router", "flow", "is-step-changed", "simulation-data-refresh-key"]))
                    ], 6))
                  : _createCommentVNode("", true),
                (infoVisible.value && !drawerVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      id: "flow-info-box",
                      ref_key: "infoBoxRef",
                      ref: infoBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", { 'drawer-visible': infoVisible.value && !drawerVisible.value }]),
                      style: _normalizeStyle({
            width: currentEditStepWidthPx.value + 'px',
            minWidth: minEditStepWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize-info",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("Flow.FlowDetails")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "close-info",
                            onClick: showInfo
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createVNode(_unref(ElDivider), { style: {"margin":"0"} }),
                        _createElementVNode("div", _hoisted_8, [
                          (flowId.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.FlowID")), 1),
                                _createElementVNode("span", null, _toDisplayString(flowId.value), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Name")), 1),
                            _hoisted_11,
                            _createVNode(_unref(ElInput), {
                              onInput: onFlowChange,
                              modelValue: flow.value.name,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((flow.value.name) = $event)),
                              ref_key: "nameInputField",
                              ref: nameInputField,
                              size: "small",
                              "input-style": 
                    flow.value.name !== undefined && flow.value.name !== ''
                      ? {}
                      : { 'border-color': 'red' }
                  ,
                              placeholder: _unref(t)('Common.Name')
                            }, null, 8, ["modelValue", "input-style", "placeholder"]),
                            (isNameNearLimit.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", {
                      limit: currentCharLimit.value,
                    })), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Description")), 1),
                            _hoisted_15,
                            _createVNode(_unref(ElInput), {
                              onInput: onFlowChange,
                              modelValue: flow.value.description,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((flow.value.description) = $event)),
                              size: "small",
                              placeholder: _unref(t)('Common.Description')
                            }, null, 8, ["modelValue", "placeholder"]),
                            (isDescriptionNearLimit.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", {
                      limit: currentCharLimit.value,
                    })), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Active")), 1),
                              _createVNode(_unref(ElSwitch), {
                                onChange: onFlowChange,
                                "active-color": "#5022a6",
                                id: "flow-active",
                                class: "element-switch-oneteg",
                                width: 48,
                                modelValue: flow.value.active,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((flow.value.active) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.ContinueOnFail")), 1),
                              _createVNode(_unref(ElSwitch), {
                                onChange: onFlowChange,
                                "active-color": "#5022a6",
                                id: "flow-continue-on-fail",
                                class: "element-switch-oneteg align-items-center",
                                width: 48,
                                modelValue: flow.value.continueOnFailure,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((flow.value.continueOnFailure) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          (aiWizardEnabled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.SkillGenerationForFlow")), 1),
                                  _createVNode(_unref(ElTooltip), {
                                    content: _unref(t)('Flow.SkillGenerationForFlowTooltip'),
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "info-circle",
                                        style: {"cursor":"default","font-size":"12px","color":"#909399"}
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["content"])
                                ]),
                                _createVNode(_unref(ElSwitch), {
                                  "active-color": "#5022a6",
                                  id: "flow-skill-generation",
                                  class: "element-switch-oneteg",
                                  width: 48,
                                  modelValue: skillGenerationEnabledModel.value,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((skillGenerationEnabledModel).value = $event))
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (isNewUiEnabled.value && flow.value.id && flow.value.latest && !flow.value.newUi)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.SwitchToNewUI")), 1),
                                  _createVNode(_unref(ElSwitch), {
                                    "active-color": "#5022a6",
                                    id: "flow-new-ui-toggle",
                                    class: "element-switch-oneteg",
                                    width: 48,
                                    onChange: onEnableNewUi
                                  })
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.createdAt || flow.value.createdBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                (flow.value.createdAt)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CreationTime")), 1),
                                      _createTextVNode(" " + _toDisplayString(_unref(convertDate)(createdAtDate.value)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (flow.value.createdBy)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CreatedBy")), 1),
                                      _createTextVNode(" " + _toDisplayString(createdByName.value?.fullName), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.updatedAt || flow.value.modifiedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                (flow.value.updatedAt)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.UpdatedAt")), 1),
                                      _createTextVNode(" " + _toDisplayString(_unref(convertDate)(flow.value.updatedAt)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (flow.value.modifiedBy)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.UpdatedBy")), 1),
                                      _createTextVNode(" " + _toDisplayString(updatedByName.value), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.modifiedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.Version")), 1),
                                _createTextVNode(" " + _toDisplayString(flow.value.version), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                  !pageLoading.value &&
                  executionList.value?.length === 0 &&
                  tenantDefaultExecution.value?.length > 0
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Execution")), 1),
                                _createElementVNode("span", _hoisted_33, [
                                  _createElementVNode("img", {
                                    class: "logo-24",
                                    src: `${_unref(ASSETS_BASE_URL)}/${
                      tenantDefaultExecution.value[0].execution?.type
                    }${_unref(getResolution)(false)}.png`,
                                    alt: "logo",
                                    style: {"margin-right":"8px"}
                                  }, null, 8, _hoisted_34),
                                  _createTextVNode(" " + _toDisplayString(`${tenantDefaultExecution.value[0].execution?.name} (${_unref(t)(
                      "Common.TenantDefault"
                    )})`), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!pageLoading.value && executionList.value?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Execution")), 1),
                                _createVNode(_unref(ElSelect), {
                                  modelValue: selectedExecution.value,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedExecution).value = $event)),
                                  size: "small",
                                  placeholder: "Select Execution",
                                  style: {"margin-bottom":"10px"},
                                  clearable: false,
                                  disabled: pageLoading.value,
                                  onChange: handleExecutionChange
                                }, {
                                  prefix: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_36, [
                                      (selectedExecution.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "logo-24",
                                            src: getLogoSrc(selectedExecution.value),
                                            alt: "logo",
                                            style: {"margin-right":"8px"}
                                          }, null, 8, _hoisted_37))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(executionList.value, (execution) => {
                                      return (_openBlock(), _createBlock(_unref(ElOption), {
                                        key: execution.id,
                                        label: 
                      execution.id === defaultExecution.value
                        ? `${execution.name} (${_unref(t)(
                            'Common.OrganizationDefault'
                          )})`
                        : execution.name
                    ,
                                        value: execution.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_38, [
                                            _createElementVNode("img", {
                                              class: "logo-24",
                                              src: `${_unref(ASSETS_BASE_URL)}/${
                          execution.type
                        }${_unref(getResolution)(false)}.png`,
                                              alt: "logo",
                                              style: {"margin-right":"8px"}
                                            }, null, 8, _hoisted_39),
                                            _createTextVNode(" " + _toDisplayString(execution.id === defaultExecution.value
                          ? `${execution.name} (${_unref(t)(
                              "Common.OrganizationDefault"
                            )})`
                          : execution.name), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.active && flow.value.scheduleType && !pageLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Schedule.Schedule")), 1),
                                _createVNode(_unref(CronEditor), {
                                  ref_key: "cronEditorRef",
                                  ref: cronEditorRef,
                                  schedule: flow.value.schedule,
                                  "schedule-type": flow.value.scheduleType,
                                  "time-zone": flow.value.timeZone,
                                  "flow-id": flow.value.id,
                                  "flow-version": flow.value.version,
                                  onUpdate: updateCronExpr,
                                  onScheduleTypeChange: handleScheduleTypeChange,
                                  onUpdateDrawer: setEditorVisible,
                                  onStepChange: onFlowChange
                                }, null, 8, ["schedule", "schedule-type", "time-zone", "flow-id", "flow-version"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.schedule && nextRunTime.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (flow.value.schedule && nextRunTime.value)
                                  ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                      key: 0,
                                      effect: "custom",
                                      placement: "auto",
                                      content: _unref(t)('Schedule.NextRunTimeTooltip')
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(t)("Schedule.NextFireTime")), 1),
                                          _hoisted_43,
                                          _createTextVNode(" " + _toDisplayString(_unref(convertDate)(nextRunTime.value)), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["content"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.active && isScheduledFlow(flow.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.TimeZone")), 1)
                                ]),
                                _createVNode(_unref(ElSelect), {
                                  onChange: handleTimezoneChange,
                                  modelValue: selectedOffset.value,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedOffset).value = $event)),
                                  id: "connection-connector-select",
                                  filterable: "",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timezoneOffsets), (offset, index) => {
                                      return (_openBlock(), _createBlock(_unref(ElOption), {
                                        key: index,
                                        value: offset.offset
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_46, _toDisplayString(offset.offset), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.flowStatusType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Status")), 1),
                                _createElementVNode("div", _hoisted_48, [
                                  _createVNode(_unref(ElTag), {
                                    type: _unref(statusColor)(flow.value.flowStatusType)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(flow.value.flowStatusType), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"]),
                                  (flow.value.flowStatusType === 'DRAFT')
                                    ? (_openBlock(), _createBlock(_unref(ElButton), {
                                        key: 0,
                                        class: "margin-left-20",
                                        style: {"text-decoration":"none"},
                                        size: "small",
                                        type: "button",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (publishFlow()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Flow.PublishFlow")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (showAIReportSection.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                _createVNode(_unref(ElDivider), { style: {"margin":"16px 0","border-color":"#e0e0e0"} }),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.AIReportGeneration")), 1),
                                  _createElementVNode("div", _hoisted_50, [
                                    (!reportExists.value)
                                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                                          key: 0,
                                          size: "small",
                                          type: "button",
                                          loading: isGenerating.value,
                                          disabled: responseLoading.value,
                                          onClick: onGenerateReport
                                        }, {
                                          default: _withCtx(() => [
                                            (!isGenerating.value)
                                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                  key: 0,
                                                  icon: "magic",
                                                  class: "margin-right-5"
                                                }))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(isGenerating.value
                          ? _unref(t)("Flow.Generating")
                          : _unref(t)("Flow.GenerateReport")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_unref(ElTooltip), {
                                            content: 
                          isReportUpToDate.value
                            ? _unref(t)('Flow.ReportAlreadyUpToDate')
                            : ''
                        ,
                                            disabled: !isReportUpToDate.value,
                                            placement: "top"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, [
                                                _createVNode(_unref(ElButton), {
                                                  size: "small",
                                                  type: "button",
                                                  loading: isGenerating.value,
                                                  disabled: responseLoading.value || isReportUpToDate.value,
                                                  onClick: onUpdateReport
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_font_awesome_icon, {
                                                      icon: isGenerating.value ? 'spinner' : 'sync',
                                                      spin: isGenerating.value,
                                                      class: "margin-right-5"
                                                    }, null, 8, ["icon", "spin"]),
                                                    _createTextVNode(" " + _toDisplayString(isGenerating.value
                                ? _unref(t)("Flow.Updating")
                                : _unref(t)("Flow.Update")), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading", "disabled"])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["content", "disabled"]),
                                          _createVNode(_unref(ElSelect), {
                                            modelValue: selectedReportFormat.value,
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedReportFormat).value = $event)),
                                            size: "small",
                                            placeholder: _unref(t)('Flow.ReportFormatPlaceholder'),
                                            style: {"width":"85px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ElOption), {
                                                label: "PDF",
                                                value: "pdf"
                                              }),
                                              _createVNode(_unref(ElOption), {
                                                label: "DOCX",
                                                value: "docx"
                                              }),
                                              _createVNode(_unref(ElOption), {
                                                label: "MD",
                                                value: "md"
                                              }),
                                              _createVNode(_unref(ElOption), {
                                                label: "JSON",
                                                value: "json"
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "placeholder"]),
                                          _createVNode(_unref(ElTooltip), {
                                            content: 
                          selectedReportFormat.value === 'pdf' && !isPdfReady.value
                            ? _unref(t)('Flow.PdfStillRendering')
                            : _unref(t)('Flow.Download')
                        ,
                                            placement: "top"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, [
                                                _createVNode(_unref(ElButton), {
                                                  size: "small",
                                                  type: "button",
                                                  loading: isRetrieving.value,
                                                  disabled: 
                              isRetrieving.value ||
                              (selectedReportFormat.value === 'pdf' && !isPdfReady.value)
                            ,
                                                  onClick: onRetrieveReport
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_font_awesome_icon, {
                                                      style: {"color":"#606266"},
                                                      icon: _unref(faDownload)
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading", "disabled"])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["content"])
                                        ], 64))
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (aiSkillGeneratorEnabled.value && flowId.value && flow.value.version != null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                                _createVNode(_unref(ElDivider), { style: {"margin":"16px 0","border-color":"#e0e0e0"} }),
                                _createElementVNode("div", _hoisted_51, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.AISkillGeneration")), 1),
                                    _createVNode(_unref(ElTooltip), {
                                      effect: "custom",
                                      placement: "top"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_53, _toDisplayString(_unref(t)("Flow.AISkillGenerationTooltip")), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "info-circle",
                                          class: "color-dark-gray margin-left-5",
                                          style: {"cursor":"default","font-size":"13px"}
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (isSkillUpToDate.value)
                                    ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                        key: 0,
                                        content: _unref(t)('Flow.SkillAlreadyUpToDate'),
                                        placement: "top"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createVNode(_unref(ElButton), {
                                              size: "small",
                                              type: "button",
                                              disabled: true
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: "check",
                                                  class: "margin-right-5 color-green"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.SkillGenerated")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["content"]))
                                    : (isAnyChange.value)
                                      ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                          key: 1,
                                          content: _unref(t)('Flow.GenerateSkillUnsavedChanges'),
                                          placement: "top"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _createVNode(_unref(ElButton), {
                                                size: "small",
                                                type: "button",
                                                disabled: true
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_font_awesome_icon, {
                                                    icon: skillExists.value ? 'sync' : 'magic',
                                                    class: "margin-right-5"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString(skillExists.value
                            ? _unref(t)("Flow.UpdateSkill")
                            : _unref(t)("Flow.GenerateSkill")), 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["content"]))
                                      : (_openBlock(), _createBlock(_unref(ElButton), {
                                          key: 2,
                                          size: "small",
                                          type: "button",
                                          loading: isGeneratingSkill.value,
                                          disabled: 
                      responseLoading.value || !flowId.value || flow.value?.version == null
                    ,
                                          onClick: onGenerateSkill
                                        }, {
                                          default: _withCtx(() => [
                                            (!isGeneratingSkill.value)
                                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                  key: 0,
                                                  icon: skillExists.value ? 'sync' : 'magic',
                                                  class: "margin-right-5"
                                                }, null, 8, ["icon"]))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(isGeneratingSkill.value
                        ? _unref(t)("Flow.Generating")
                        : skillExists.value
                        ? _unref(t)("Flow.UpdateSkill")
                        : _unref(t)("Flow.GenerateSkill")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled"]))
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (flow.value.currentActivityStatus)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CurrentActivityStatus")), 1),
                                _createElementVNode("div", _hoisted_55, [
                                  _createVNode(_unref(ElTag), {
                                    type: _unref(statusColor)(flow.value.currentActivityStatus)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(flow.value.currentActivityStatus), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_56,
                          _createElementVNode("div", _hoisted_57, [
                            (flow.value)
                              ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                  key: 0,
                                  class: "scrollable-tooltip",
                                  effect: "custom",
                                  placement: "left"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass([
                        'scrollable-tooltip-content',
                        {
                          'overflow-auto':
                            _unref(t)('Flow.FlowReportTooltip').length > 100,
                        },
                      ])
                                    }, _toDisplayString(_unref(t)("Flow.FlowReportTooltip")), 3)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElCheckbox), {
                                      onChange: onFlowChange,
                                      modelValue: flow.value.sendFlowReport,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((flow.value.sendFlowReport) = $event)),
                                      label: "Send Activity Report on Each Completion",
                                      size: "large"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          (flow.value.sendFlowReport)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                _createElementVNode("div", _hoisted_59, [
                                  _hoisted_60,
                                  _createVNode(_unref(ElInput), {
                                    onInput: onFlowChange,
                                    modelValue: flow.value.notifyUsers,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((flow.value.notifyUsers) = $event)),
                                    onKeyup: _cache[19] || (_cache[19] = ($event: any) => (handleEmails(flow.value.notifyUsers))),
                                    size: "small",
                                    placeholder: "Enter emails separated by ;"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_61, _toDisplayString(invalidEmail.value), 1)
                                ]),
                                _createVNode(_unref(ElCheckbox), {
                                  onChange: onFlowChange,
                                  modelValue: flow.value.onSuccess,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((flow.value.onSuccess) = $event)),
                                  label: "On Success",
                                  size: "large",
                                  disabled: !flow.value.notifyUsers
                                }, null, 8, ["modelValue", "disabled"]),
                                _createVNode(_unref(ElCheckbox), {
                                  onChange: onFlowChange,
                                  modelValue: flow.value.onError,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((flow.value.onError) = $event)),
                                  label: "On Error",
                                  size: "large",
                                  disabled: !flow.value.notifyUsers
                                }, null, 8, ["modelValue", "disabled"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 6))
                  : _createCommentVNode("", true),
                (userVariableVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      ref_key: "userVarsBoxRef",
                      ref: userVarsBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", [{ 'drawer-visible': userVariableVisible.value }]]),
                      style: _normalizeStyle({
            width: currentEditStepWidthPx.value + 'px',
            minWidth: minEditStepWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "close-info",
                            onClick: showUserVariables
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CustomFieldDefinitions")), 1),
                            _createElementVNode("div", _hoisted_66, [
                              _createVNode(_unref(ElButton), {
                                class: "no-border btn-oneTeg2",
                                size: "mini",
                                type: "primary",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (addUserDefinedVariables()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "plus" })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          (userDefinedVariables.value.length > 0)
                            ? (_openBlock(), _createBlock(_unref(ElDivider), {
                                key: 0,
                                style: {"margin":"10px 0"}
                              }))
                            : _createCommentVNode("", true),
                          (userDefinedVariables.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(t)("Common.Variable")), 1),
                                _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(t)("Common.Value")), 1),
                                _hoisted_70
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userDefinedVariables.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "d-flex align-items-start justify-content-center gap-2 full-width"
                            }, [
                              _createElementVNode("div", {
                                id: 'variable-' + index + '-div',
                                class: "d-flex flex-column margin-top-10 udv-field-column"
                              }, [
                                _createVNode(_unref(ElInput), {
                                  modelValue: item.value.itemKey,
                                  "onUpdate:modelValue": ($event: any) => ((item.value.itemKey) = $event),
                                  id: 'variable-input-' + index,
                                  onKeydown: preventLetters,
                                  onInput: 
                      (e) => updateUserDefinedVariables(e, 'itemKey', index)
                    ,
                                  size: "mini",
                                  class: "full-width"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onInput"])
                              ], 8, _hoisted_71),
                              _createElementVNode("div", {
                                id: 'value-' + index + '-div',
                                class: "d-flex flex-column margin-top-10 udv-field-column"
                              }, [
                                _createVNode(_unref(ElInput), {
                                  modelValue: item.value.itemValue,
                                  "onUpdate:modelValue": ($event: any) => ((item.value.itemValue) = $event),
                                  id: 'value-input-' + index,
                                  onInput: 
                      (e) => updateUserDefinedVariables(e, 'itemValue', index)
                    ,
                                  size: "mini",
                                  class: "full-width"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onInput"])
                              ], 8, _hoisted_72),
                              _createElementVNode("div", _hoisted_73, [
                                _createElementVNode("button", {
                                  class: "btn btn-link icon-btn udv-action-btn",
                                  type: "button",
                                  onClick: ($event: any) => (removeUserDefinedVariables(index))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "trash" })
                                ], 8, _hoisted_74)
                              ])
                            ]))
                          }), 128)),
                          _hoisted_75
                        ])
                      ])
                    ], 6))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                  ref_key: "wizardBoxRef",
                  ref: wizardBoxRef,
                  id: "wizard-drawer-box",
                  class: _normalizeClass(["background-fb z-index-15", [{ 'drawer-visible': wizardDrawerVisible.value }]]),
                  style: _normalizeStyle({
            width: currentWizardWidthPx.value + 'px',
            minWidth: minWizardWidth.value + 'px',
            maxWidth: '1500px',
          })
                }, [
                  _createElementVNode("div", {
                    id: "resize-wizard",
                    class: "resize-item",
                    onPointerdown: startResize
                  }, null, 32),
                  _createVNode(WizardDrawer, {
                    ref_key: "wizardDrawerRef",
                    ref: wizardDrawerRef,
                    inline: "",
                    visible: wizardDrawerVisible.value,
                    "flow-id": flowId.value || undefined,
                    "flow-version": version.value ? Number(version.value) : undefined,
                    "flow-name": flow.value?.name || '',
                    "current-flow-snapshot": currentWizardFlowSnapshot.value,
                    "skill-generation-enabled": skillGenerationEnabled.value,
                    onClose: closeWizardDrawer,
                    onFlowCreated: handleWizardFlowCreated,
                    onHistoryVisibilityChange: handleWizardHistoryVisibilityChange,
                    onApprovalStateChanged: handleWizardApprovalStateChange
                  }, null, 8, ["visible", "flow-id", "flow-version", "flow-name", "current-flow-snapshot", "skill-generation-enabled"])
                ], 6), [
                  [_vShow, wizardDrawerVisible.value]
                ]),
                (conditionVisible.value && selectedStep.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      ref_key: "conditionBoxRef",
                      ref: conditionBoxRef,
                      id: "condition-box",
                      class: _normalizeClass(["background-fb z-index-15", [
            {
              'drawer-visible': conditionVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ]]),
                      style: _normalizeStyle({
            width: currentConditionWidthPx.value + 'px',
            minWidth: minConditionWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize-condition",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      _createElementVNode("div", {
                        class: _normalizeClass(["card card-drawer background-fb filter-condition-card", `oneteg-drawer-${getSizeByValue(filterSize.value)}`])
                      }, [
                        _createElementVNode("div", _hoisted_76, [
                          _createTextVNode(_toDisplayString(_unref(t)("Common.Filter")) + " ", 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "condition-close",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (showCondition()))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _createVNode(_unref(Condition), {
                              conditions: selectedStep.value.filter || [],
                              onOnChange: changeFilter,
                              "output-list": 
                    outputList.value.filter(
                      (item) =>
                        selectedStep.value.availableOutput.some(
                          (x) => x.uniqueId === item.uniqueId
                        ) || selectedStep.value.uniqueId === item.uniqueId
                    )
                  ,
                              "metaoutput-list": 
                    metaoutputList.value.filter(
                      (item) =>
                        selectedStep.value.availableMetaoutput.some(
                          (x) => x.uniqueId === item.uniqueId
                        ) || selectedStep.value.uniqueId === item.uniqueId
                    )
                  ,
                              "step-index": selectedIndex.value,
                              "id-suffix": '',
                              "user-defined-variables": userDefinedVariables.value,
                              "system-variables": systemVariables.value,
                              expressions: expressions.value,
                              onChangeFunctionsVisible: changeFunctionsVisible,
                              onChangesHappened: _cache[24] || (_cache[24] = ($event: any) => (updateStep(true))),
                              onClose: showCondition
                            }, null, 8, ["conditions", "output-list", "metaoutput-list", "step-index", "user-defined-variables", "system-variables", "expressions"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("button", {
                            class: "btn btn-link",
                            onClick: removeFilter
                          }, _toDisplayString(_unref(t)("Common.RemoveFilter")), 1),
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg3 filter-condition-close",
                            "native-type": "button",
                            size: "mini",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (showCondition()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Close")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ], 2)
                    ], 6))
                  : _createCommentVNode("", true),
                (routerVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      ref_key: "routerBoxRef",
                      ref: routerBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", [
            {
              'drawer-visible': routerVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ]]),
                      id: "router-step-box",
                      style: _normalizeStyle({
            width: currentRouterWidthPx.value + 'px',
            minWidth: minRouterWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      (_openBlock(), _createBlock(_unref(EditRoute), {
                        key: selectedStep.value ? selectedStep.value.id : 'editRoute',
                        onClose: closeRouterSettings,
                        class: _normalizeClass(`oneteg-drawer-${getSizeByValue(routerSize.value)}`),
                        "is-new-ui": false,
                        step: selectedStep.value,
                        "step-index": selectedIndex.value,
                        "output-list": outputListFilter(),
                        "metaoutput-list": metaoutputListFilter(),
                        "user-defined-variables": userDefinedVariables.value,
                        "system-variables": systemVariables.value,
                        expressions: expressions.value,
                        onOnChange: onRouterChange,
                        onRemoveStep: removeStep,
                        onChangeFunctionVisible: changeFunctionsVisible,
                        onCloseDrawer: closeRouterSettings,
                        onChangesHappened: _cache[26] || (_cache[26] = ($event: any) => (updateStep(true)))
                      }, null, 8, ["class", "step", "step-index", "output-list", "metaoutput-list", "user-defined-variables", "system-variables", "expressions"]))
                    ], 6))
                  : _createCommentVNode("", true),
                (delayVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: _normalizeClass([[{ 'drawer-visible': delayVisible.value }], "background-fb z-index-15"])
                    }, [
                      _createVNode(_unref(EditDelay), {
                        class: "oneteg-drawer-small",
                        name: selectedStep.value.name,
                        "existing-delay": selectedStep.value.delay,
                        onClose: openDelay,
                        onChange: changeDelay
                      }, null, 8, ["name", "existing-delay"])
                    ], 2))
                  : _createCommentVNode("", true),
                (configurationVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass([[{ 'drawer-visible': configurationVisible.value }], "background-fb z-index-15"])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card border-0 background-fb", `oneteg-drawer-${getSizeByValue(detailsSize.value)}`])
                      }, [
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("Common.FlowSettings")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "close-info",
                            onClick: showConfiguration
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          (tree.value.length)
                            ? (_openBlock(), _createBlock(_unref(ElInput), {
                                key: 0,
                                modelValue: filterText.value,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((filterText).value = $event)),
                                size: "small",
                                style: {"margin-bottom":"10px"},
                                placeholder: _unref(t)('Common.Filter')
                              }, null, 8, ["modelValue", "placeholder"]))
                            : _createCommentVNode("", true),
                          _createVNode(_unref(ElScrollbar), { "max-height": '65vh' }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_82, [
                                _createVNode(_unref(ElTree), {
                                  ref_key: "treeRef",
                                  ref: treeRef,
                                  style: {"max-width":"500px"},
                                  data: tree.value,
                                  class: "filter-tree",
                                  props: defaultProps,
                                  "default-expand-all": "",
                                  "filter-node-method": filterNode
                                }, {
                                  default: _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_83, [
                                      (isTextLong(data.description))
                                        ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                            key: 0,
                                            content: data.description,
                                            effect: "custom",
                                            placement: "top"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(data.description), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["content"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(data.description), 1)),
                                      (!data.children || data.children.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                            (data.enumerationValues.length > 0)
                                              ? (_openBlock(), _createBlock(_unref(ElSelect), {
                                                  key: 0,
                                                  modelValue: data.inputValue,
                                                  "onUpdate:modelValue": ($event: any) => ((data.inputValue) = $event),
                                                  size: "small",
                                                  placeholder: "Select value",
                                                  id: 'select-' + data.label,
                                                  onChange: ($event: any) => (handleInputValueChange(data, $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.enumerationValues, (option) => {
                                                      return (_openBlock(), _createBlock(_unref(ElOption), {
                                                        key: option,
                                                        label: option,
                                                        value: option
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue", "id", "onChange"]))
                                              : (_openBlock(), _createBlock(_unref(ElInput), {
                                                  key: 1,
                                                  modelValue: data.inputValue,
                                                  "onUpdate:modelValue": ($event: any) => ((data.inputValue) = $event),
                                                  size: "small",
                                                  placeholder: _unref(t)('Common.EnterValue'),
                                                  id: 'input-' + data.label,
                                                  onFocus: ($event: any) => (handleInputFocus(data)),
                                                  onChange: ($event: any) => (handleInputChange(data))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "id", "onFocus", "onChange"]))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["data"])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (activeTab.value === 2)
            ? (_openBlock(), _createBlock(_unref(FlowVersions), {
                key: 1,
                onSwitch: switchFlow,
                onUpdateLoading: updateResponseLoading,
                onGoToEdit: setActiveOne,
                showClose: true
              }))
            : _createCommentVNode("", true),
          (activeTab.value === 3)
            ? (_openBlock(), _createBlock(_unref(Activities), {
                key: 2,
                showClose: true,
                onGoToEdit: setActiveOne
              }))
            : _createCommentVNode("", true),
          (aiWizardEnabled.value)
            ? (_openBlock(), _createBlock(TaggyPromo, {
                key: 3,
                "promo-hidden": isTeggyPromoHidden.value,
                "screen-key": taggyScreenKey.value,
                "screen-visible": isTaggySurfaceVisible.value,
                "wizard-open": wizardDrawerVisible.value,
                onHidePromo: handleHideTeggyPromo,
                onOpenWizard: openWizardDrawer
              }, null, 8, ["promo-hidden", "screen-key", "screen-visible", "wizard-open"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_86, [
            _createElementVNode("div", _hoisted_87, [
              (flowId.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_88, [
                    _createElementVNode("li", {
                      id: "flow-tab-information",
                      class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': infoVisible.value }]),
                      onClick: showInfo
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: 
                  flow.value.name !== undefined && flow.value.name !== ''
                    ? 'custom'
                    : 'customized'
                ,
                        content: _unref(t)('Common.Information'),
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_89, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "info",
                              class: "fa-fw",
                              size: "lg"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["effect", "content"])
                    ], 2),
                    (hasConfigurationData.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': configurationVisible.value }]),
                          onClick: showConfiguration
                        }, [
                          _createVNode(_unref(ElTooltip), {
                            effect: "custom",
                            content: _unref(t)('Common.FlowSettings'),
                            placement: "left"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_90, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "cog",
                                  size: "lg"
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["nav-item-border width-100", {
                'active-flow-tab': activeTab.value === item.tab && !infoVisible.value,
              }]),
                        onClick: ($event: any) => (setActive(item.tab)),
                        key: item.tab
                      }, [
                        _createVNode(_unref(ElTooltip), {
                          effect: "custom",
                          content: item.tooltip,
                          placement: "left"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_92, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: item.icon,
                                class: "fa-fw",
                                size: "lg"
                              }, null, 8, ["icon"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ], 10, _hoisted_91))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_93, [
                    _createElementVNode("li", {
                      id: "flow-tab-information",
                      class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': infoVisible.value }]),
                      onClick: showInfo
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: 
                  flow.value.name !== undefined && flow.value.name !== ''
                    ? 'custom'
                    : 'customized'
                ,
                        content: _unref(t)('Common.Information'),
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_94, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "info",
                              class: "fa-fw",
                              size: "lg"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["effect", "content"])
                    ], 2)
                  ])),
              _createElementVNode("ul", _hoisted_95, [
                _createElementVNode("li", {
                  id: "flow-tab-custom-field-definitions",
                  class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': userVariableVisible.value }]),
                  onClick: showUserVariables
                }, [
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    content: _unref(t)('Common.CustomFieldDefinitions'),
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_96, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "dollar-sign",
                          size: "lg"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ], 2)
              ]),
              _createElementVNode("ul", _hoisted_97, [
                (aiWizardEnabled.value)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      id: "taggy-wizard-trigger",
                      class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': wizardDrawerVisible.value }]),
                      onClick: openWizardDrawer
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: "custom",
                        content: _unref(t)('TeggyAssistant.Tooltip'),
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_98, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "magic",
                              size: "lg"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_unref(ElColorPicker), {
                  modelValue: backgroundColor.value,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((backgroundColor).value = $event)),
                  class: "margin-top-10",
                  size: "small",
                  "show-alpha": "",
                  predefine: predefinedColors.value
                }, null, 8, ["modelValue", "predefine"])
              ])
            ]),
            _createElementVNode("div", _hoisted_100, [
              _createVNode(_unref(ElSlider), {
                modelValue: zoomScale.value,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((zoomScale).value = $event)),
                vertical: "",
                height: "140px",
                step: 10,
                "show-stops": "",
                "format-tooltip": (t) => t + 50,
                onChange: zoom
              }, null, 8, ["modelValue", "format-tooltip"])
            ]),
            (activeTab.value === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  (flowId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                        (showSimulateRegular.value)
                          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                              key: 0,
                              effect: "custom",
                              content: _unref(t)('Flow.ProceedStep'),
                              placement: "left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-link btn-simulate",
                                  id: "flow-simulate-step",
                                  disabled: stepSimulating.value || disableSimulateButton.value,
                                  onClick: _cache[30] || (_cache[30] = ($event: any) => (simulateSelectedStep(false)))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "step-forward" })
                                ], 8, _hoisted_103)
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true),
                        (showSimulateRouterChild.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_unref(ElTooltip), {
                                effect: "custom",
                                content: _unref(t)('Flow.ProceedStep'),
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-link btn-simulate",
                                    id: "flow-simulate-router-child-step",
                                    disabled: stepSimulating.value || disableSimulateButton.value,
                                    onClick: _cache[31] || (_cache[31] = ($event: any) => (simulateSelectedStep(false)))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: "step-forward" })
                                  ], 8, _hoisted_104)
                                ]),
                                _: 1
                              }, 8, ["content"]),
                              _hoisted_105,
                              _createVNode(_unref(ElTooltip), {
                                effect: "custom",
                                content: _unref(t)('Flow.ProceedBypassStep'),
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-link btn-simulate",
                                    id: "flow-simulate-step-bypass",
                                    disabled: stepSimulating.value || disableSimulateButton.value,
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (simulateSelectedStep(true)))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "eject",
                                      style: {"rotate":"90deg"}
                                    })
                                  ], 8, _hoisted_106)
                                ]),
                                _: 1
                              }, 8, ["content"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (showSimulateControls.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_107))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(ElTooltip), {
                          effect: "custom",
                          content: _unref(t)('Flow.Run'),
                          placement: "left"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["btn btn-link", { 'margin-top-10': stepSimulating.value }]),
                              id: "flow-draft-run",
                              disabled: stepSimulating.value,
                              onClick: _cache[33] || (_cache[33] = ($event: any) => (runFlow(flow.value.name)))
                            }, [
                              (!stepSimulating.value)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "play"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: "pause"
                                  }))
                            ], 10, _hoisted_108)
                          ]),
                          _: 1
                        }, 8, ["content"]),
                        _hoisted_109,
                        (canStopFlow.value)
                          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                              key: 3,
                              effect: "custom",
                              content: _unref(t)('Flow.Stop'),
                              placement: "left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-link margin-top-10",
                                  id: "flow-draft-stop",
                                  disabled: !canStopFlow.value || !stepSimulating.value,
                                  onClick: stopRunningFlow
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "stop" })
                                ], 8, _hoisted_110)
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    content: `${
              flow.value.latest ? _unref(t)('Common.Save') : _unref(t)('Flow.Revert')
            } (CTRL/COMMAND + S)`,
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      (flow.value.latest)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            id: "flow-save-button",
                            class: "btn btn-oneTeg2 margin-bottom-10",
                            onClick: onFlowSubmit,
                            disabled: isSubmitting.value || shortCutPressed.value
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "save",
                              class: "fa-fw",
                              size: "1x"
                            })
                          ], 8, _hoisted_111))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            id: "flow-revert-button",
                            class: "btn btn-oneTeg2 margin-bottom-10",
                            onClick: flowRevert,
                            disabled: shortCutPressed.value
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "undo",
                              class: "fa-fw",
                              size: "1x"
                            })
                          ], 8, _hoisted_112))
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_113, [
          _createElementVNode("img", {
            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
            alt: "Loading...",
            class: "loader-logo-40"
          }, null, 8, _hoisted_114)
        ], 512), [
          [_vShow, responseLoading.value || pageLoading.value || configResponseLoading.value]
        ]),
        (visibleOutputDailog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
              _createVNode(_unref(OutputDataDialog), {
                dialog: visibleOutputDailog.value,
                outputData: showingStepOutputData.output,
                moved: false,
                title: `${showingStepOutputData.index + 1}. Step's Output Data`,
                onClose: _cache[34] || (_cache[34] = ($event: any) => (visibleOutputDailog.value = false)),
                index: showingStepOutputData.index + 1
              }, null, 8, ["dialog", "outputData", "title", "index"])
            ]))
          : _createCommentVNode("", true),
        (runFlowDialog.value)
          ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
              key: 1,
              dialog: runFlowDialog.value,
              selectedBuffer: outputLogs.value,
              moved: false,
              flowName: flowName.value,
              stoppable: true,
              onDownloadLogsAsText: _cache[35] || (_cache[35] = ($event: any) => (downloadLogsAsText(flow.value))),
              onClose: closeFlowDialog
            }, null, 8, ["dialog", "selectedBuffer", "flowName"]))
          : _createCommentVNode("", true),
        _hoisted_116
      ], 4))
    : _createCommentVNode("", true)
}
}

})